import { useSelector, useDispatch } from 'react-redux';
import { authActions } from '_store';
import { useState, useRef, useEffect } from 'react';
import axios from 'axios';

import { EditorState, ContentState, convertFromHTML, convertToRaw, getDefaultKeyBinding } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';

import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

import draftToHtml from 'draftjs-to-html';
import { date } from 'yup';
import {ReactPictureAnnotation } from "react-picture-annotation";
import QRCode from "react-qr-code";

import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";

export { StudyList };
var search_report_status = 'P';
var search_priority = 'A';
var myWindow = null;
var patientObject = new Object();

var myWindowJPG = null;
let scale = 1;
let rotateDeg = 0;
let flipped = false;
let fullscreenFlag = false;
let showImageAreaFlag = true;
let showReportAreaFlag = true;

const Msg = ({ closeToast, toastProps }) => (
  <div>
    Custom Message {toastProps.position}
    <button>Retry</button>
    <button onClick={closeToast}>Close</button>
  </div>
);

function StudyList(prop) {
    const authUser = useSelector(x => x.auth.user);
    const dispatch = useDispatch();
    const logout = () => dispatch(authActions.logout());

    const [patientFilesData, setPatientFilesData] = useState([]);
    const [activitylogData, setActivitylogData] = useState([]);
    const [doctorListData, setDoctorListData] = useState([]);
    const [assignDoctorKey, setAssignDoctorKey] = useState(0);

    const [patientData, setPatientData] = useState([]);
    const [patientIndex, setPatientIndex] = useState(0);
    const [pageIndex, setPageIndex] = useState(1);
    const [reportIndex, setReportIndex] = useState(1);

    const [filterColName, setFilterColName] = useState("");
    const [filterColValue, setFilterColValue] = useState("");
    const [sortColName, setSortColName] = useState("");
    const [sortColValue, setSortColValue] = useState("");
    
    const [pendingCount, setPendingCount] = useState(0);
    const [waitingCount, setWaitingCount] = useState(0);
    const [holdCount, setHoldCount] = useState(0);
    const [draftCount, setDraftCount] = useState(0);
    const [signedoffCount, setSignedoffCount] = useState(0);
    const [urgentCount, setUrgentCount] = useState(0);

    const [editorState, setEditorState] = useState(
      () => EditorState.createEmpty(),
    );
    
    const [reportLineHeight, setReportLineHeight] = useState("");
    const [printLineHeight, setPrintLineHeight] = useState("");
    
    const content = editorState.getCurrentContent();
    const dataToSaveBackend = convertToRaw(content);
    const markupReport = draftToHtml(
      dataToSaveBackend
    );

    let divStyle1 = {
      float: "left",
      marginTop: "4rem",
      marginLeft: "30px",
    };
    let divStyle2 = {
      border: "#dadada 1px solid"/*,
      height: "135px",*/
    };
    let divStyle3 = {
      float: "right",
      marginTop: "4rem",
      marginRight: "30px",
    };
    let displayNone = {
      display: "none"
    };
    
    const [fileList, setFile] = useState();
    const [fileCount, setFileCount] = useState(0);
    const files = fileList ? [...fileList] : [];
    
    const [notesFile, setNotesFile] = useState();
    const [notesFileCount, setNotesFileCount] = useState(0);
    const notesFiles = notesFile ? [...notesFile] : [];
    
    const [pageSize, setPageSize] = useState({
      width: window.innerWidth ,
      height: window.innerHeight 
    });
    const [jpgPath, setJpgPath] = useState('#');

    const [alertDesc, setAlertDesc] = useState("");
    const [autoClose0, setAutoClose0] = useState(0);
    const [autoClose5, setAutoClose5] = useState(5000);
    const [autoCloseTime, setAutoCloseTime] = useState(0);
    
    const notifyDefault = (msgValue) => {
      toast(msgValue);
    };
  const notifySuccess = (msgValue) => {
    setTimeout(function () {
      toast.success(msgValue, {
        position: "top-right"
      });
    }, 100);
      
    };
  const notifyError = (msgValue) => {
    
    setTimeout(function () {
      toast.error(msgValue, {
        position: "top-right"
      });
    }, 100);

    //let modalAlert = document.querySelector("#modal_alert");
    //modalAlert.classList.toggle("closed");

    };
    const notifyWarn = (msgValue) => {
      toast.warn(msgValue, {
        position: "top-right"
      });
    };
    const notifyInfo = (msgValue) => {
      toast.info(msgValue, {
        position: "top-right"
      });
    };
    const notifyCustom = (msgValue) => {
      toast(msgValue, {
        position: "top-right",
        className: 'foo-bar'
      });
    };
    //toast('Show now');
    //toast('Show after 1sec', { delay: 1000 });

    const displayMsg = () => {
      toast(<Msg />);
      // toast(Msg) would also work
    };

    const onResize = () => {
      setPageSize({ width: window.innerWidth, height: window.innerHeight });
    };
  
    const onSelectDicomJPG = selectedId => console.log(selectedId);
    const onChangeDicomJPG = data => console.log(data);
  
      var prev_filter_col_name = "";
      var prev_sort_col_name = "";
      var prev_dicomobj = null;

    useEffect(() => {
        if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && 1===2){
          document.getElementById("lnkpageno1").parentNode.style.display='none';
          document.getElementById("lnkpageno2").parentNode.style.display='none';
          document.getElementById("lnkpageno3").parentNode.style.display='none';
          
          document.getElementById("lnkpagenoLast").parentNode.style.display='';
          document.getElementById("lnkpagenomore").parentNode.style.display='';
        }

        search_report_status = 'P';
        search_priority = 'A';
        tabClick(search_report_status, search_priority);

        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, []);

    // only show Menu when logged in
    if (!authUser) return null;

    /*
      setTimeout(function() {
        patientStudyList(search_report_status, search_priority, null, false, true);
      }, 600000);
    */

  //setInterval(RefreshPage, 60000);
   
  function lineHeightChange() {
    var objddlLineHeight = document.getElementById("ddlLineHeight");
    const LineHeight = objddlLineHeight.options[objddlLineHeight.selectedIndex].innerHTML;
    var lineHeightValue = 0;
    if(LineHeight==='Line Height - Default') { lineHeightValue = 0; }
    else if(LineHeight==='Line Height - 1') { lineHeightValue = 10; }
    else if(LineHeight==='Line Height - 1.3') { lineHeightValue = 13; }
    else if(LineHeight==='Line Height - 1.5') { lineHeightValue = 15; }
    else if(LineHeight==='Line Height - 1.8')  { lineHeightValue = 18; }
    else if(LineHeight==='Line Height - 2') { lineHeightValue = 20; }
    else if(LineHeight==='Line Height - 2.3') { lineHeightValue = 23; }
    else if(LineHeight==='Line Height - 2.5') { lineHeightValue = 25; }
    else if(LineHeight==='Line Height - 2.8')  { lineHeightValue = 28; }

    if(lineHeightValue === 0) { 
      setReportLineHeight(""); 
      setPrintLineHeight(""); 
    }
    else { 
      var lineHeightValuePixel = lineHeightValue + "px";
      setReportLineHeight(lineHeightValuePixel); 

      lineHeightValue = lineHeightValue - 5;
      lineHeightValuePixel = lineHeightValue + "px";
      setPrintLineHeight(lineHeightValuePixel);
    }
  }

   function RefreshPage(){
    //alert('refresh...');
    if(myWindow !== null){
      if(myWindow.closed){
        if(prev_dicomobj!=null){
          //prev_dicomobj.classList.remove("bi-eye-slash");
          //prev_dicomobj.classList.add("bi-eye-fill");
        }
      }
    }
    return true;
   }

   const copyClipboard = (event, index, patient_key) => {
    event.preventDefault();
 
    var textCopy = 'Patient: ' + patientData[index].patient_id + ' - ' + patientData[index].patient_name 
      + ', Age/Sex: ' + patientData[index].patient_age.toString() 
      + patientData[index].patient_age_unit + '-' + patientData[index].patient_sex
      + '\r\nStudy: ' + patientData[index].modality + ' - ' + patientData[index].study_description;

    navigator.clipboard.writeText(textCopy).then(() => {
      //alert("Text copied to clipboard!");
      var objbtnCopyClip = document.getElementById(`btnCopyClip_`+ patient_key.toString());
      if(objbtnCopyClip!==null){
        objbtnCopyClip.classList.remove("bi-clipboard");
        objbtnCopyClip.classList.add("bi-clipboard-check");
      }
    }).catch(err => {
      console.error("Failed to copy text: ", err);
    });
    
  };

   function pageClick(index, report_status, priority, refreshGrid) {
    if(refreshGrid===undefined){
      refreshGrid = true;
    }

    var objtxtpage_no_s = document.getElementById("txtpage_no_s");
    var page_count = parseInt(objtxtpage_no_s.tag, 10);

    var page_index = 0; var objlnkpageno; var objlnkpageno_old;

    var objpageFirst = document.getElementById("pageFirst");
    var objpageLast = document.getElementById("pageLast");
    var objpagePrev = document.getElementById("pagePrev");
    var objpageNext = document.getElementById("pageNext");

    if(index === 0){
      objlnkpageno = document.getElementById("lnkpagenoLast");
      page_index = page_count;
    }
    else{
      objlnkpageno = document.getElementById("lnkpageno"+ index.toString());
      if(objlnkpageno===null){
        page_index = index;  
      }
      else{
        page_index = parseInt(objlnkpageno.innerText, 10);
      }
    }

    if(pageIndex === page_count || index === page_count){
      objlnkpageno_old = document.getElementById("lnkpagenoLast");
    }
    else{
      objlnkpageno_old = document.getElementById("lnkpageno"+ pageIndex.toString());
    }

    if(page_index === 1 || page_count === 1 || page_count === 0){
      objpageFirst.classList.add('disabled');
      objpagePrev.classList.add('disabled');
    }
    else
    {
      objpageFirst.classList.remove('disabled');
      objpagePrev.classList.remove('disabled');
    }

    if(page_count === 1 || page_index === page_count){
      objpageLast.classList.add('disabled');
      objpageNext.classList.add('disabled');
    }
    else 
    {
      objpageLast.classList.remove('disabled');
      objpageNext.classList.remove('disabled');
    }

    if((page_index > 0 && page_index <= page_count) || refreshGrid)
    {
      if(objlnkpageno_old!==null){
        objlnkpageno_old.parentNode.classList.remove("active");
      }
      if(objlnkpageno!==null){
        objlnkpageno.parentNode.classList.add("active");
      }
      setPageIndex(page_index);

      if(report_status===undefined){
        report_status = search_report_status;
      }
      if(priority===undefined){
        priority = search_priority;
      }

      if(refreshGrid)
      {
        patientStudyList(report_status, priority, page_index, false);
      }
    }
   }

   function pageSearch () {
    var objtxtpage_no_s = document.getElementById("txtpage_no_s");
    var page_count = parseInt(objtxtpage_no_s.tag, 10);
    if(parseInt(objtxtpage_no_s.value, 10) > 0 && parseInt(objtxtpage_no_s.value, 10) <= page_count)
    {
      var page_index = parseInt(objtxtpage_no_s.value, 10);
      setPageIndex(page_index);
      patientStudyList(search_report_status, search_priority, page_index, false);
    }
    else{
      alert('Invalid page number searching, ' + objtxtpage_no_s.title);
    }
   }
   function pagePrev()
   {
    pageNavigate('Prev');
   }
   function pageNext()
   {
      pageNavigate('Next');
   }
   function pageNavigate(actionFlag)
   {
      var objtxtpage_no_s = document.getElementById("txtpage_no_s");
      var page_count = parseInt(objtxtpage_no_s.tag, 10);

      var page_index = pageIndex;
      var processFlag = false;
      if(actionFlag==='Next'){
        if(page_index < page_count){
          page_index++;
          processFlag = true;
        }
      }
      else if(actionFlag==='Prev'){
        if(page_index > 1){
          page_index--;
          processFlag = true;
        }
      }

      if(processFlag){
        pageClick(page_index);
      }
   }
   function pageSizeChange(page_index, refresh) {
    if(page_index===undefined || page_index===null){
      page_index = pageIndex;
    }

    var objddlpage_size_s = document.getElementById("ddlpage_size_s");
    const page_size = objddlpage_size_s.options[objddlpage_size_s.selectedIndex].innerHTML;
  
    var objbtnpagesearch = document.getElementById("btnpagesearch");
    var paginateCount = parseInt(objbtnpagesearch.value, 10);
    
    var objtxtpage_no_s = document.getElementById("txtpage_no_s");
    var page_count = 0;
    if(page_size > 0 && paginateCount > 0){
      page_count = paginateCount/page_size;
      var arraypage_count = page_count.toString().split('.');
      
      if(arraypage_count.length>1)
      {
        page_count = parseInt(arraypage_count[0], 10);
        if(parseInt(arraypage_count[1], 10)>0){
          page_count++;
        }
      }
    }
    if(page_count===0){
      page_index = page_count;
    }
    objtxtpage_no_s.placeholder = page_index.toString() + ' of ' + parseInt(page_count, 10).toString();
    objtxtpage_no_s.title = 'Total Page: ' + parseInt(page_count, 10).toString();
    objtxtpage_no_s.tag = page_count;

    var objlnkpagenoLast = document.getElementById("lnkpagenoLast");
    objlnkpagenoLast.innerText = page_count;

    if(refresh){
      pageClick(1);
    }
   }

  function sortClick (event, column_name){
    var sort_col_name = column_name;
    var sort_col_value = '';

    if(event.target.className.indexOf("arrow-up")>=0)
    {
      sort_col_value = "DESC";

      //event.target.classList.remove('icon-muted');

      event.target.classList.remove('bi-arrow-up');
      event.target.classList.add('bi-arrow-down');
    }
    else
    {
      sort_col_value = "ASC";

      event.target.classList.remove('bi-arrow-down');
      event.target.classList.add('bi-arrow-up');
    }

    if(prev_sort_col_name!== sort_col_name){
      prev_sort_col_name = sort_col_name;
    }

    setSortColName(sort_col_name);
    setSortColValue(sort_col_value);

    patientStudyList(search_report_status, search_priority,  null, false, null, null, null, sort_col_name, sort_col_value);
  }
  const handleSearchChange = (event) => {
      var filter_col_name = event.target.id;
      var filter_col_value = event.target.value; 
      var forceReset = false;
      if(filter_col_name==='regn_date'){
        forceReset = true;
        if(filter_col_value===''){
          filter_col_name = ''; 
          filter_col_value = '';
        }
        else{
          var value_split = filter_col_value.split('-');
            filter_col_value = value_split[2] + '-' + value_split[1] + '-' + value_split[0];
        }
      }

      //alert( filter_col_name + ': ' + filter_col_value);

      if(prev_filter_col_name!== filter_col_name){
        prev_filter_col_name = filter_col_name;
      }


      if(filter_col_name==='patient_name'
        || filter_col_name==='modality'
        || filter_col_name==='report_status_desc')
      {
        filter_col_value = filter_col_value + '%';
        forceReset = true;
      }

      setFilterColName(filter_col_name);
      setFilterColValue(filter_col_value);

      patientStudyList(search_report_status, search_priority, null, forceReset, null, filter_col_name, filter_col_value, null, null);
      //setPatientData({ ...patientData, [event.target.name]: event.target.value });
    };

    function randomNumberInRange(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }
    function tabReportClick(event, reportNo)
    {
      if(event!==null){
        event.preventDefault();
      }

      document.getElementById('report'+reportIndex.toString()+'-tab').tag = markupReport;

      setReportIndex(reportNo);
      var report_content = document.getElementById('report'+reportNo.toString()+'-tab').tag;
      report_content = report_content.replace(/ins>/g, "u>");
      setEditorState(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(report_content))));
    }
    function tabAddClick()
    {
      var report_count = parseInt(document.getElementById('myReportTab').tag, 10);
      document.getElementById('report'+(report_count+1).toString()+'-tab').style.display = '';
      
      if(report_count===3)
      {
        document.getElementById('btnreportadd').style.display = 'none';
      }
      document.getElementById('btnreportremove').style.display = '';
      
      document.getElementById('myReportTab').tag = (report_count+1).toString();
      
      document.getElementById('report'+(report_count+1).toString()+'-tab').ariaSelected = false;
      document.getElementById('report'+(report_count+1).toString()+'-tab').classList.remove("active");
    }
    function tabRemoveClick()
    {
      var report_count = parseInt(document.getElementById('myReportTab').tag, 10);
      if(report_count>1)
      {
        document.getElementById('report'+report_count.toString()+'-tab').tag = '';
        document.getElementById('report'+report_count.toString()+'-tab').style.display = 'none';
      }      
      
      if(report_count===2)
      {
        document.getElementById('btnreportremove').style.display = 'none';
      }
      document.getElementById('btnreportadd').style.display = '';
      document.getElementById('myReportTab').tag = (report_count-1).toString();
      
      if(reportIndex===report_count){

        document.getElementById('report'+reportIndex.toString()+'-tab').ariaSelected = false;
        document.getElementById('report1-tab').ariaSelected = true;

        document.getElementById('report'+reportIndex.toString()+'-tab').classList.remove("active");

        document.getElementById('report1-tab').classList.remove("active");
        document.getElementById('report1-tab').classList.add("active");
        
        tabReportClick(null, 1);
      }
    }
    function tabClick(report_status, priority) {
      patientStudyList(report_status, priority, 1, true);
    }
    function refreshExpiryToken()
    {
      return prop.refreshToken();
    }
    function patientStudyList(report_status, priority, page_index, forceReset, autoRefresh, filter_col_name, filter_col_value, sort_col_name, sort_col_value) {
      if(forceReset===undefined || forceReset === null){
        forceReset = false;
      }
      if(autoRefresh===undefined || autoRefresh === null){
        autoRefresh = false;
      }

      if(prev_dicomobj!=null){
        //prev_dicomobj.classList.remove("bi-eye-slash");
        //prev_dicomobj.classList.add("bi-eye-fill");
      }

      search_report_status = report_status;
      search_priority = priority;
      var objddlpage_size_s = document.getElementById("ddlpage_size_s");
      
      const page_size = objddlpage_size_s.options[objddlpage_size_s.selectedIndex].innerHTML;
      const url = `${process.env.REACT_APP_API_URL}/patients`;
      
      const user_key = authUser?.user_key;
      const center_key = authUser?.center_key;
      
      if(page_index===undefined || page_index===null){
        page_index = pageIndex;
      }

      if(filter_col_name===undefined || filter_col_name===null){
        filter_col_name = filterColName;
        filter_col_value = filterColValue;
      }
      
      if(sort_col_name===undefined || sort_col_name===null){
        sort_col_name = sortColName;
        sort_col_value = sortColValue;
      }

      const request_id = randomNumberInRange(1000000, 9000000);
      const userJSON = localStorage.getItem('user');
      let validToken = true;
      if(userJSON===null){
        validToken = false;
      }
      
      if(validToken)
      {
        if(JSON.parse(userJSON)===undefined){
          validToken = false;
        }
      }

      if(validToken)
      {
        if(JSON.parse(userJSON).token===undefined){
          validToken = false;
        }
      }

      if(!validToken){
        alert('Session expired, try to relogin.');
         logout();
         //refreshExpiryToken();
        return false;
      }
      const token = JSON.parse(userJSON).token;

      const config = {
        headers: {
          'content-type': 'application/json',
          //'Access-Control-Allow-Origin': '*',
          //'Access-Control-Allow-Methods': 'POST,PATCH,OPTIONS',
          'Authorization': `Bearer ${token}`,
          'user_key': user_key.toString(),
          'center_key': center_key.toString(),
          'report_status': report_status,
          'priority': priority,
          'request_id': request_id.toString(),
          'page_index': page_index.toString(),
          'page_size': page_size,
          'filter_col_name': filter_col_name,
          'filter_col_value': filter_col_value,
          'sort_col_name': sort_col_name,
          'sort_col_value': sort_col_value
        },
      };
  //alert(sort_col_name + ' - ' + sort_col_value); 
      try {
        
        if(!autoRefresh){
          ProcessStatus(true, false, filter_col_value);
        }

        axios.get(url, config).then((response) => {
          //alert('response'); alert(JSON.stringify(response.data));
          //console.log(response.data);
          //console.log(JSON.stringify(response.data));

         //var total_count = response?.headers?.["X-Total-Count"];
         //var paginate_count = response?.headers?.["X-Total-Paginate"];

        let updatedValue = {};
        updatedValue = response.data; 
        
        var record_exist = false;
        if(updatedValue.length>0){
          if(updatedValue[0].patient_key>0){
            record_exist = true;
          }
          setPendingCount(updatedValue[0].pending_count);
          setWaitingCount(updatedValue[0].waiting_count);
          setHoldCount(updatedValue[0].hold_count);
          setDraftCount(updatedValue[0].draft_count);
          setSignedoffCount(updatedValue[0].signedoff_count);
          setUrgentCount(updatedValue[0].urgent_count);
          if(updatedValue[0].urgent_count>0)
          {
            document.title = '('+updatedValue[0].urgent_count.toString()+')Teleradiology';
          }
          else{
            document.title = 'Teleradiology';
          }
         }
         else
         {
          setPendingCount(0);
          setWaitingCount(0);
          setHoldCount(0);
          setDraftCount(0);
          setSignedoffCount(0);
          setUrgentCount(0);
          document.title = 'Teleradiology';
         }
        
         ProcessStatus(false, record_exist, filter_col_value);
         
         if(record_exist || forceReset){
            //const data = JSON.stringify(response.data);

            if(record_exist){
              setPatientData(updatedValue);
            }
            else
            {
              setPatientData([]); 
            }
            
            var paginateCount = 0;
            if(updatedValue.length>0){
             paginateCount = updatedValue[0].paginateCount;
            }
            var objbtnpagesearch = document.getElementById("btnpagesearch");
            objbtnpagesearch.value = paginateCount;
            
            pageSizeChange(page_index, false);

            if(forceReset){
              pageClick(page_index, report_status, priority, false);

              var objtxtpage_no_s = document.getElementById("txtpage_no_s");
              var page_count = parseInt(objtxtpage_no_s.tag, 10);
              
              if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)  && 1===2){
               ; 
              }
              else {

                if(page_count < 4) {
                  document.getElementById("lnkpagenoLast").parentNode.style.display='none';
                  document.getElementById("lnkpagenomore").parentNode.style.display='none';
                }
                else {
                  document.getElementById("lnkpagenoLast").parentNode.style.display='';
                  document.getElementById("lnkpagenomore").parentNode.style.display='';
                }

                if(page_count < 3) {
                  document.getElementById("lnkpageno3").parentNode.style.display='none';
                }
                else {
                  document.getElementById("lnkpageno3").parentNode.style.display='';
                }

                if(page_count < 2) {
                  document.getElementById("lnkpageno2").parentNode.style.display='none';
                }
                else {
                  document.getElementById("lnkpageno2").parentNode.style.display='';
                }
              }
            }
         }

          /*
          setPatientData(patientData => ({
              ...patientData,
              ...updatedValue
              }));
          */
              

        })
       .catch(error => {
        if(error.response.data.message==='Unauthorized')
        {
          alert('Unauthorized session, try to relogin.');
          logout();
        }
        else{
          ProcessStatus(false, false, filter_col_value);
          alert(error.response.data.message);
        }
       });

      } catch (err) {
        ProcessStatus(false, false, filter_col_value);
        //alert('error');
          //alert(err.code);
        if (err.code === '404') {
          //setError('Object does not exist.')
          return
        }
      }
  
    }
    function ProcessStatus(buttonDisabled, record_exist, filter_col_value) {
      if(buttonDisabled){
        document.getElementById("divLoading").style.display = '';
        document.getElementById("divLoading").innerHTML = 'Processing...';
      }
      else
      {
        document.getElementById("divLoading").innerHTML = '';
        document.getElementById("divLoading").style.display = 'none';

        if(record_exist)
         {
            document.getElementById("divStatusResult").innerHTML = '';
            document.getElementById("divStatusResult").style.display = 'none';
         }
         else{
            document.getElementById("divStatusResult").style.display = '';
            
            if(filter_col_value===''){
              document.getElementById("divStatusResult").innerHTML = 'No Record Found!';
            }
            else{
              document.getElementById("divStatusResult").innerHTML = 'Search value '+filter_col_value+' does not found any record.';
            }
         }
      }
    }

    function handleChangeUploadFile(e) {
      if (e.target.files) {
        setFileCount(e.target.files.length);
        setFile(e.target.files);
  
        if (window.File && window.FileReader && window.FileList && window.Blob) {
          const files = e.target.files;
          //console.log(files[1].name);
  
          const output = document.querySelector("#attachFileResult");
          output.innerHTML = "";
          for (let i = 0; i < files.length; i++) {
            if (!files[i].type.match("image")) continue;
            const picReader = new FileReader();
            // console.log(picReader);
            picReader.addEventListener("load", function (event) {
              const picFile = event.target;
              //console.log(picFile);
              const div = document.createElement("div");
              div.className = "col-2";
              div.innerHTML = `<div class ="mb-2"><div id="display_report`+i.toString()+`"><img class ="thumbnail2" src="${picFile.result}"/>
              <div class ="row float-right py-2 px-2">
              <div class ="col-4">
              <button type="button" style="display:none" class ="btn btn-outline-danger btn-sm hist-btn bi bi-cloud-arrow-down-fill" title="Download"></button>
              </div>
              <div class ="col-4">
              <button type="button" class ="btn btn-outline-danger btn-sm hist-btn bi-box-arrow-up-right" title="Show" onclick="window.open('${picFile.result}', 'mytsoftdicom-attachfile')"></button>
              </div>
              <div class ="col-4">
              <button type="button" style="display:none" class ="btn btn-outline-danger btn-sm hist-btn bi bi bi-trash3-fill" title="Remove"></button>
              </div>                                
              </div>
              </div>
              </div>`;
              output.appendChild(div);
            });
            picReader.readAsDataURL(files[i]);
          }
        } else {
          alert("Your browser does not support File API");
        }
      }
    }

    function handleChangeNotesFile(e) {
      if (e.target.files) {
        setNotesFileCount(e.target.files.length);
        setNotesFile(e.target.files);
      }
    }
    const selectAssignDoctor = (event, doctor_key) => {
      //event.preventDefault();
      setAssignDoctorKey(doctor_key);
    }

    const openAssignDoctor = (event, param, index) => {
      event.preventDefault();

      if(index!=null){
        setPatientIndex(index);
      }
 
      if(param === 'OPEN'){
        document.getElementById("spnassign_doctor").innerHTML = patientData[index].patient_name + ', Center: ' + patientData[index].center_name;

        document.getElementById("hidc_key_assigndr").value = patientData[index].center_key;
        document.getElementById("hidp_key_assigndr").value = patientData[index].patient_key;

        document.getElementById("hiddoctor_key").value = patientData[index].doctor_key;

        if (!authUser) return null;

        const url = `${process.env.REACT_APP_API_URL}/doctor`;
  
        const user_key = authUser?.user_key;
        const center_key = patientData[index].center_key;
        const patient_key = patientData[index].patient_key;
        const doctor_key = patientData[index].doctor_key;

        const request_id = randomNumberInRange(1000000, 9000000);
        const token = JSON.parse(localStorage.getItem('user')).token;
        const action_tag = "";
        const config = {
          headers: {
            'content-type': 'application/json',
            'Authorization': `Bearer ${token}`,
            'user_key': user_key.toString(),
            'center_key': center_key.toString(),
            'patient_key': patient_key.toString(),
            'doctor_key': doctor_key.toString(),
            'action_tag': action_tag,
            'request_id': request_id.toString()
          },
        };
    
        try {
          
          setDoctorListData([]); 

          axios.get(url, config).then((response) => { 
            let updatedValue = {};
            if(response.data.length>0){
              updatedValue = response.data; 
            }
           
           setDoctorListData(updatedValue); 
          })
          
        .catch(error => {
          var Unauthorized = false; var errorCatch = '';
          if(error.response!= null)
          {
            errorCatch = 'Exception found!';
            if(error.response.data != null)
            {
              if(error.response.data.message==='Unauthorized')
              {
                Unauthorized = true;
              }
              else
              {
                errorCatch = error.response.data.message;
              }
            }
          }
          else if(error.message!= null)
          {
            errorCatch = error.message;
          }

          if(Unauthorized)
          {
            alert('Unauthorized session, try to relogin.');
            logout();
          }
          else{
            alert(errorCatch);
          }
         });
        } catch (err) {
          //debugger;
            //alert(err.code);
          if (err.code === '404') {
            //setError('Object does not exist.')
            return
          }
        }

      }

      if(index!=null && 1===2){

        setTimeout(function() {
          if(document.getElementById("hidp_key_assigndr").value!==patientData[index].patient_key.toString())
          {
            alert('Wrong patient details updating, refresh and try again.');
            return false;
          }

          if(document.getElementById("hidc_key_assigndr").value!==patientData[index].center_key.toString())
          {
            alert('Wrong center patient updating, refresh and try again.');
            return false;
          }
        }, 1000);
      }

      if(param==='SAVE'){
        index = patientIndex;

        var action_tag = 'ASSIGN_DOCTOR';
        var user_key = authUser?.user_key; 
        
        var report_count = 1;
        var report_content = '';
        var report_content2 = '';
        var report_content3 = '';
        var report_content4 = '';

        var notes = '';

        var center_key = document.getElementById("hidc_key_assigndr").value;
        var patient_key = document.getElementById("hidp_key_assigndr").value;
        var doctor_key_old = document.getElementById("hiddoctor_key").value;
        var doctor_key = assignDoctorKey;
        if(doctor_key===0){
          alert('Please select available doctor/radiologist');
          return false;
        }
        
        if(doctor_key.toString()===doctor_key_old){
          alert('Selected doctor/adiologist is already assigned');
          return false;
        }

        if(patient_key!==patientData[index].patient_key.toString())
        {
          alert('Wrong patient details updating, refresh and try again.');
          return false;
        }

        if(center_key!==patientData[index].center_key.toString())
        {
          alert('Wrong center patient updating, refresh and try again.');
          return false;
        }

        updateStudy(index, action_tag, user_key, patientData[index].center_key, patientData[index].patient_key, report_count, report_content, report_content2, report_content3, report_content4, notes,patientData[index].patient_name,patientData[index].patient_age,patientData[index].patient_sex,patientData[index].study_description,patientData[index].refer_physician,patientData[index].remarks,patientData[index].priority,patientData[index].patient_age_unit, '', patientData[index].patient_id_ref, doctor_key);
      }

      let modal = document.querySelector("#modalAssignDoctor");
      modal.classList.toggle("closed");
    };
    
    const openEditStudy = (event, param, index) => {
      event.preventDefault();

      if(index!=null){
        setPatientIndex(index);
      }

      if(index!=null){
        document.getElementById("spnedit_patient").innerHTML = patientData[index].patient_name;

        if(patientData[index].report_status === "F") 
        {
          //document.getElementById('btnEditSave').disabled = true;
          document.getElementById('chkurgent').disabled = true;
        }
        
        if(patientData[index].report_content === '') 
        {
          document.getElementById('txtstudyname').title = '';
          document.getElementById('txtstudyname').disabled = false;
        }
        else
        {
          document.getElementById('txtstudyname').title = 'Add notes if any correction required';
          document.getElementById('txtstudyname').disabled = true;
        }

        if(patientData[index].report_status === "F" || patientData[index].report_status === "S") 
        {
          document.getElementById('txthistory').disabled = true;
          document.getElementById('historyFiles').disabled = true;
        }
        else
        {
          document.getElementById('btnEditSave').disabled = false;
          document.getElementById('historyFiles').disabled = false;

          document.getElementById('chkurgent').disabled = false;
          document.getElementById('txthistory').disabled = false;
        }

        document.getElementById("hidc_key").value = patientData[index].center_key;
        document.getElementById("hidp_key").value = patientData[index].patient_key;

        document.getElementById("txtp_id").value = patientData[index].patient_id;
        document.getElementById("txtp_name").value = patientData[index].patient_name;
        document.getElementById("txtage").value = patientData[index].patient_age;
        var patient_age_unit_d = patientData[index].patient_age_unit;
        if(patient_age_unit_d===""){
          patient_age_unit_d="Y";
        }
        document.getElementById("ddlage_unit").value = patient_age_unit_d;
        document.getElementById("txtgender").value = patientData[index].patient_sex;
        document.getElementById("txtp_id_ref").value = patientData[index].patient_id_ref;
        document.getElementById("txtstudyname").value = patientData[index].study_description; 
        document.getElementById("txtphysician_name").value = patientData[index].refer_physician;
        document.getElementById("txthistory").value = patientData[index].remarks;
        if(patientData[index].priority === "Y"){
          document.getElementById("chkurgent").checked = true;
        }
        else
        {
          document.getElementById("chkurgent").checked = false;
        }

        document.getElementById('historyFiles').value = '';
        setFileCount(0);
        setFile(null);
        
        document.getElementById("hidattachcount").value = patientData[index].attach_file_count;
        document.getElementById("hidattachjson").value = patientData[index].attach_json_data;

        const output = document.querySelector("#attachFileResult");
        output.innerHTML = "";
      
        if(patientData[index].attach_file_count> 0){
          var attachJSON = JSON.parse(patientData[index].attach_json_data);
          
          for (let i = 0; i < attachJSON.files.length; i++) {
            //if (!files[i].type.match("image")) continue;
            const picReader = new FileReader();
            // console.log(picReader);
            //picReader.addEventListener("load", function (event) {
              
              //console.log(picFile);
              const div = document.createElement("div");
              div.className = "col-2";
              div.innerHTML = `<div class ="mb-2"><div id="display_report`+i.toString()+`"><img class ="thumbnail2" src="${attachJSON.files[i].fileUrl}"/>
              <div class ="row float-right py-2 px-2">
              <div class ="col-4">
              <button type="button" style="display:none;" class ="btn btn-outline-danger btn-sm hist-btn bi bi-cloud-arrow-down-fill" title="Download" onclick="AttachImageAction('D',${i},'${attachJSON.files[i].fileUrl}')"></button>
              </div>
              <div class ="col-4">
              <button type="button" class ="btn btn-outline-danger btn-sm hist-btn bi-box-arrow-up-right" title="Show" onclick="window.open('${attachJSON.files[i].fileUrl}', 'mytsoftdicom-attachfile')"></button>
              </div>
              <div class ="col-4">
              <button type="button" style="display:none;" class ="btn btn-outline-danger btn-sm hist-btn bi bi bi-trash3-fill" title="remove" onclick="AttachImageAction('R',${i},'${attachJSON.files[i].fileUrl}')"></button>
              </div>                                
              </div>
              </div>
              </div>`;
              output.appendChild(div);
            //});
            //picReader.readAsDataURL(attachJSON.files[i].fileUrl);
          }
        }

        setTimeout(function() {
          if(document.getElementById("hidp_key").value!==patientData[index].patient_key.toString())
          {
            alert('Wrong patient details updating, refresh and try again.');
            return false;
          }

          if(document.getElementById("hidc_key").value!==patientData[index].center_key.toString())
          {
            alert('Wrong center patient updating, refresh and try again.');
            return false;
          }
        }, 1000);
      }

      if(param==='SAVE'){
        index = patientIndex;

        if(authUser?.user_type === 'D')
        {
          alert('Permission denied for the user');
          return false;
        }

        /*if(patientData[index].report_status === "F")
        {
          alert('Cannot allow to edit after printed.');
          return false;
        }*/

        var action_tag = 'EDIT_PATIENT';
        var user_key = authUser?.user_key; 
        
        var report_count = 1;
        var report_content = '';
        var report_content2 = '';
        var report_content3 = '';
        var report_content4 = '';

        var notes = '';

        var center_key = document.getElementById("hidc_key").value;
        var patient_key = document.getElementById("hidp_key").value;

        var patient_id = document.getElementById("txtp_id").value;
        var patient_name = document.getElementById("txtp_name").value;
        var patient_age = document.getElementById("txtage").value;
        var patient_age_unit = document.getElementById("ddlage_unit").value;
        var patient_sex = document.getElementById("txtgender").value;
        var patient_id_ref = document.getElementById("txtp_id_ref").value;
        var study_description = document.getElementById("txtstudyname").value; 
        var refer_physician = document.getElementById("txtphysician_name").value;
        var remarks = document.getElementById("txthistory").value;
        var priority = 'N';
        
        if(document.getElementById("chkurgent").checked){
          priority = 'Y';
        }

        if(patient_id===''){
          alert('Patient id cannot be blank');
          return false;
        }
        if(patient_name===''){
          alert('Patient name cannot be blank');
          return false;
        }
        if(patient_age==='' || patient_age==='0'){
          alert('Patient age cannot be blank');
          return false;
        }
        else
        {
          patient_age = parseFloat(patient_age);
        }

        if(patient_age===0){
          alert('Patient age cannot be blank, numberic value only');
          return false;
        }
        else{
          var patient_age_tmp = patient_age.toString().split(`.`);
          if( patient_age_tmp.length>1){
              if(patient_age_unit===`Y`)
              {
                if(parseFloat(patient_age_tmp[1]) > 11)
                {
                  alert('Invalid patient age in months, cannot exceed 11months and convert to year.');
                  return false;
                }
              }
              else if(patient_age_unit===`M`)
              {
                if(parseFloat(patient_age_tmp[1]) > 30)
                {
                  alert('Invalid patient age in days, cannot exceed 30days and convert to month.');
                  return false;
                }
              }
              else if(patient_age_unit===`D`)
              {
                if(parseFloat(patient_age_tmp[1]) > 0)
                {
                  alert('Invalid patient age in days, avoid decimal digit.');
                  return false;
                }
              }
            }
        }
        
        if(patient_sex===''){
          alert('Patient gender cannot be blank');
          return false;
        }
        else
        {
          patient_sex = patient_sex.substring(0, 1);
        }

        if(study_description===''){
          alert('Study name cannot be blank');
          return false;
        }

        if(patient_key!==patientData[index].patient_key.toString())
        {
          alert('Wrong patient details updating, refresh and try again.');
          return false;
        }

        if(center_key!==patientData[index].center_key.toString())
        {
          alert('Wrong center patient updating, refresh and try again.');
          return false;
        }

        updateStudy(index, action_tag, user_key, patientData[index].center_key, patientData[index].patient_key, report_count, report_content, report_content2, report_content3, report_content4, notes,patient_name,patient_age,patient_sex,study_description,refer_physician,remarks,priority, patient_age_unit,'', patient_id_ref);
      }

      let modal = document.querySelector("#modal");
      modal.classList.toggle("closed");
    };
    
    function ChangeStudyStatus(action_tag, index, dicomUrl, center_key, patient_key, viewerName)
    {
      if(center_key===null){
        center_key = patientData[index].center_key;
        patient_key = patientData[index].patient_key;
      }
      
      var notes = '';
      if(action_tag === 'UNLOCK_STUDY'){
        if(patientData[index].report_status !== 'S'){
          alert(`Signed-off status allow to rework study.`);
          return false;
        }
        let unlockReason = prompt(`Please enter reason for unlock`, ``);
        if(unlockReason===null){
          return false;
        }
        if(unlockReason===null || unlockReason === ''){
          alert(`Unlock reason is mandatory.`);
          return false;
        }
        notes= 'Unlock Reason: '+unlockReason;
      }
      else if(action_tag === 'REWORK_STUDY'){
        if(patientData[index].report_status !== 'F'){
          alert(`Printed status allow to unlock study.`);
          return false;
        }
        let reworkReason = prompt(`Please enter reason for rework`, ``);
        if(reworkReason===null){
          return false;
        }
        if(reworkReason===null || reworkReason === ''){
          alert(`Rework reason is mandatory.`);
          return false;
        }
        notes= 'Rework Reason: '+reworkReason;
      }
      else if(action_tag === 'COPY_STUDY'){
        if(window.confirm('Are you sure want to copy the study, Id: '+patientData[index].patient_id+'?')!== true) 
        {
          return false;
        }
      }

      var user_key = authUser?.user_key; 
      var report_count = 1;
      var report_content = '';
      var report_content2 = '';
      var report_content3 = '';
      var report_content4 = '';
      const priority = 'N';
      const patient_id_ref = '';
      var status = updateStudy(index, action_tag, user_key, center_key, patient_key, report_count, report_content, report_content2, report_content3, report_content4, notes, '', 0, '', '', '', '', priority, '', dicomUrl, patient_id_ref, null, viewerName);
      return status;
    }

    function updateStudy(index, action_tag, user_key, center_key, patient_key, report_count, report_content, report_content2, report_content3, report_content4, notes,patient_name,patient_age,patient_sex,study_description,refer_physician,remarks,priority,patient_age_unit,dicomUrl,patient_id_ref, doctor_key, viewerName) {
      var url = `${process.env.REACT_APP_API_URL}/patients/Patient`;

      if(priority===null){
        priority='';
      }
      if(doctor_key===null || doctor_key===undefined){
        doctor_key=0;
      }
      if(viewerName===null || viewerName===undefined){
        viewerName='';
      }

      // 👇 Create new FormData object and append files
      const data = new FormData();
      data.append(`user_key`, user_key.toString());
      data.append(`center_key`, center_key.toString());
      data.append(`patient_key`, patient_key.toString());
      data.append(`action_tag`, action_tag.toString());
      
      data.append(`report_count`, report_count);
      data.append(`report_content`, report_content);
      data.append(`report_content2`, report_content2);
      data.append(`report_content3`, report_content3);
      data.append(`report_content4`, report_content4);

      data.append(`notes`, notes);
      data.append(`patient_name`, patient_name);
      data.append(`patient_age`, patient_age);
      data.append(`patient_age_unit`, patient_age_unit);
      data.append(`patient_sex`, patient_sex);
      data.append(`study_description`, study_description);
      data.append(`refer_physician`, refer_physician);
      data.append(`remarks`, remarks);
      data.append(`priority`, priority);
      data.append(`patient_id_ref`, patient_id_ref);

    if (action_tag === "EDIT_PATIENT") {
      data.append(`attach_uploadfile_count`, fileCount.toString());

      if(fileCount>0){
        url = `${process.env.REACT_APP_API_URL_EC2}/patients/Patient`;

        files.forEach((file, i) => {
          data.append(`AttachUploadFiles`, file, file.name);
        });
      }
    }

    if (action_tag === "ADD_NOTES") {
      data.append(`attach_uploadfile_count`, notesFileCount.toString());

      if(notesFileCount>0){ 
        url = `${process.env.REACT_APP_API_URL_EC2}/patients/Patient`;

        notesFiles.forEach((file, i) => {
          data.append(`AttachUploadFiles`, file, file.name);
        });
      }
    }

    if(action_tag === 'ASSIGN_DOCTOR'){
      data.append(`doctor_key`, doctor_key.toString());
    }

      const token = JSON.parse(localStorage.getItem('user')).token;
      const config = {
        headers: {
          'content-type': 'multipart/form-data',
          'Authorization': `Bearer ${token}`
        },
      };
  
      try {
          axios.post(url, data, config).then((response) => {
          //console.log(response.data);
          //alert(JSON.stringify(response.data));
          
         // console.log(JSON.stringify(response.data));

         var refreshgrid = false;
         
         if(action_tag === 'LOCK_DICOM' || action_tag === 'LOCK_PATIENT'){
          let updatedValue = {};
          updatedValue = response.data;
          
          var error_code = updatedValue.error_code;
          var error_msg = updatedValue.error_msg;
          
          /*//temp allow asif doctor, no need to lock
          if(authUser?.user_key === 78 || authUser?.user_key === 79)
          {
            error_code='';
          }*/

          if(error_code === '' && search_report_status ==='P' && search_report_status!==updatedValue.report_status){
            alert(`Patient status is changed to `+updatedValue.report_status_desc+`, please refresh and try again.`);
          }
          else if(error_code === ''){
            if(action_tag === 'LOCK_DICOM'){
              
              openDicomViewer(patientData[index].patient_key, patientData[index].study_key, patientData[index].instance_uid, patientData[index].modality, patientData[index].image_total_count, dicomUrl, viewerName);

              if(search_report_status==='P'){
                setTimeout(function() {
                  var caller = '';
                  if(action_tag === 'LOCK_DICOM'){
                    caller = 'DICOM';
                  }
                  openSubmitReportCallBack('OPEN', index, caller);
                }, 1);
              }
            }
            else
            {
              openSubmitReportCallBack('OPEN', index, '');
            }
          }
          else{
            alert('Study is locked by ' + error_msg);
          }
        }
        else if (action_tag === 'REMOVE_LOCK'){
          openSubmitReportCallBack('CLOSE', index, '');
        }
        else if(action_tag === 'COPY_STUDY'){
          alert('Patient study is copied');
          refreshgrid= true;
        }
        else if(action_tag === 'UNLOCK_STUDY'){
          //if(search_report_status !== 'A'){
            refreshgrid= true;
          //}
        }
        else if(action_tag === 'PRINT_STUDY' || action_tag === 'EXPORT_RTF_STUDY'){
          //if(search_report_status !== 'A'){
            refreshgrid= true;
          //}
        }
        else if(action_tag === 'REWORK_STUDY'){
          //if(search_report_status !== 'A'){
            refreshgrid= true;
          //}
        }
        else if(action_tag === 'ASSIGN_DOCTOR'){
          let updatedValue = {};
          updatedValue = response.data;
          
          var error_code = updatedValue.error_code;
          var error_msg = updatedValue.error_msg;
          
          if (error_msg === ''){
            patientData[index].doctor_key = doctor_key;
            refreshgrid= true;
            
            setTimeout(function () {
              alert('Radiologist assigned successfully.');
            }, 100);
          }
          else{
            alert('Study is locked by ' + error_msg);
          }
        }
        else if(action_tag === 'ADD_NOTES'){
          patientData[index].notes = notes;
          refreshgrid= true;

          setNotesFileCount(0);
          setNotesFile(null);

          /*setTimeout(function () {
            alert('Notes added successfully.');
          }, 100);*/
          setAutoCloseTime(autoClose5);
          notifySuccess('Notes added successfully.');
        }
        else if(action_tag === 'REPORT_SUBMIT' || action_tag === 'REPORT_SUBMIT_SIGNOFF'){
          patientData[index].report_content = report_content;
          patientData[index].report_content2 = report_content2;
          patientData[index].report_content3 = report_content3;
          patientData[index].report_content4 = report_content4;
          patientData[index].report_count = report_count;

          if(action_tag === 'REPORT_SUBMIT_SIGNOFF') { refreshgrid= true; }

          if(action_tag === 'REPORT_SUBMIT_SIGNOFF' && search_report_status !== 'A'){
            refreshgrid= true;
          }
        }
        else if(action_tag === 'EDIT_PATIENT'){
          if(patientData[index].patient_id_ref !== patient_id_ref){
            refreshgrid= true;
          }
          else if(patientData[index].patient_name !== patient_name){
            refreshgrid= true;
          }
          else if(patientData[index].patient_age !== patient_age){
            refreshgrid= true;
          }
          else if(patientData[index].patient_age_unit !== patient_age_unit){
            refreshgrid= true;
          }
          else if(patientData[index].patient_sex !== patient_sex){
            refreshgrid= true;
          }
          else if(patientData[index].priority !== priority){
            refreshgrid= true;
          }
          else if(patientData[index].study_description !== study_description){
            refreshgrid= true;
          }
          else if(patientData[index].remarks !== remarks){
            refreshgrid= true;
          }
          else if(patientData[index].attach_file_count !== fileCount){
            refreshgrid= true;
          }

          if(!refreshgrid){
            patientData[index].patient_name = patient_name;
            patientData[index].patient_age = patient_age;
            patientData[index].patient_sex = patient_sex;
            patientData[index].study_description = study_description; 
            patientData[index].refer_physician = refer_physician;
            patientData[index].remarks = remarks;
            patientData[index].priority = priority;
          }
          setTimeout(function () {
            alert('Details modified successfully.');
          }, 100);
        }

        if(refreshgrid){
          //alert(refreshgrid);
          patientStudyList(search_report_status, search_priority, null, true);
        }

         /*let updatedValue = {};
          updatedValue = response.data; //JSON.stringify(response.data);
          //alert(updatedValue);
          setPatientData(patientData => ({
              ...patientData,
              ...updatedValue
              }));
              */
        })
        .catch(error => {
          var Unauthorized = false; var errorCatch = '';
          if(error.response!= null)
          {
            errorCatch = 'Exception found!';
            if(error.response.data != null)
            {
              if(error.response.data.message==='Unauthorized')
              {
                Unauthorized = true;
              }
              else
              {
                errorCatch = error.response.data.message;
              }
            }
          }

          if(Unauthorized)
          {
            alert('Unauthorized session, try to relogin.');
            logout();
          }
          else{
            alert(errorCatch);
          }
         });
      } catch (err) {
          alert(err.code);
        if (err.code === '404') {
          //setError('Object does not exist.')
          return
        }
      }
    }
  function openDicomViewer(patient_key, study_key, instance_uid, modality, image_total_count, dicomUrl, viewerName)
  {
    const dicomUrl_ohif = `https://dev-ohif.mytsofts.com/viewer/dicomjson?url=https://dev-ohif.mytsofts.com/json_ohif/` + study_key +`/` + instance_uid + `.json`;

    if(viewerName==='ohif'){
      dicomUrl = dicomUrl_ohif;
    }
    else{
      var considerMedream = false;
      /*if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
        if(authUser?.user_key === 9 || authUser?.user_key === 20)
        {
          considerMedream = true;
        }
      }*/
      if(authUser?.user_key === 9 || authUser?.user_key === 20)
      {
        considerMedream = true;
      }
      else if (modality === 'CT' || modality === 'US')
      {
        considerMedream = true;
      }
      
      if(considerMedream === true){
        ;
      }
      else if (image_total_count < 4 && patient_key > 16883){
          if(image_total_count === 1 || (authUser?.user_key === 11 
            || authUser?.user_key === 47 || authUser?.user_key === 2 
            || authUser?.user_key === 78 || authUser?.user_key === 79))
          {
          //&& (authUser?.user_key === 1 || authUser?.user_key === 2 || authUser?.user_key === 20)
          dicomUrl = dicomUrl_ohif;
          }
      }
    }

    if(myWindow === null){
      myWindow = window.open(dicomUrl, "mytsoftdicom");
    }
    else
    {
      if(myWindow.closed){
        myWindow = window.open(dicomUrl, "mytsoftdicom");
      }
      else
      {
        myWindow.location.href = dicomUrl;
      }
    } 
    return;
  }
    const openDicomJPG = (user_key, center_key, patient_key) => {
        
        if (!authUser) return null;
        
        const url = `${process.env.REACT_APP_API_URL}/patientfiles`;
        const request_id = randomNumberInRange(1000000, 9000000);
        const token = JSON.parse(localStorage.getItem('user')).token;
        const action_tag = "";
        const config = {
          headers: {
            'content-type': 'application/json',
            'Authorization': `Bearer ${token}`,
            'user_key': user_key.toString(),
            'center_key': center_key.toString(),
            'patient_key': patient_key.toString(),
            'action_tag': action_tag,
            'request_id': request_id.toString()
          },
        };
        
        try {
          
          setPatientFilesData([]); 
          setJpgPath('#');
          
          axios.get(url, config).then((response) => { 
            let updatedValue = {};
             
            if(response.data.length>0){
              updatedValue = response.data; 
              setJpgPath(updatedValue[0].file_name);
            }
            setPatientFilesData(updatedValue); 
          })
          
        .catch(error => {
          //alert('error');
          var Unauthorized = false; var errorCatch = '';
          if(error.response!= null)
          {
            errorCatch = 'Exception found!';
            if(error.response.data != null)
            {
              if(error.response.data.message==='Unauthorized')
              {
                Unauthorized = true;
              }
              else
              {
                errorCatch = error.response.data.message;
              }
            }
          }
          else if(error.message!= null)
          {
            errorCatch = error.message;
          }

          if(Unauthorized)
          {
            alert('Unauthorized session, try to relogin.');
            logout();
          }
          else{
            alert(errorCatch);
          }
         });
        } catch (err) {
          //debugger;
          //alert('error');
            //alert(err.code);
          if (err.code === '404') {
            //setError('Object does not exist.')
            return
          }
        }
    };

    const zoomIn = (event) => {
      event.preventDefault();
    
      scale += 0.1;
      applyTransform();
    }
    
    const zoomOut = (event) => {
      event.preventDefault();
    
      scale = Math.max(scale - 0.1, 0.1);
      applyTransform();
    }
    
    const rotate = (event) => {
      event.preventDefault();
      
      rotateDeg = (rotateDeg + 90) % 360;
      applyTransform();
    }
    
    const flip = (event) => {
      event.preventDefault();

      flipped = !flipped;
      applyTransform();
    }
    
    const pan = (event, direction) => {
      event.preventDefault();
    
      const image = document.getElementById('mainImage');
        const panAmount = 20;
        switch (direction) {
            case 'left':
                image.style.transform += ` translateX(-${panAmount}px)`;
                break;
            case 'right':
                image.style.transform += ` translateX(${panAmount}px)`;
                break;
            case 'up':
                image.style.transform += ` translateY(-${panAmount}px)`;
                break;
            case 'down':
                image.style.transform += ` translateY(${panAmount}px)`;
                break;
            default:
                image.style.transform += ` translateY(${panAmount}px)`;
                break;
        }
    }
    
    const invert = (event) => {
      event.preventDefault();

      const image = document.getElementById('mainImage');
      image.style.filter = image.style.filter === 'invert(1)' ? 'none' : 'invert(1)';
    }
    const magnify = (event) => {
      event.preventDefault();

      const magnifyAmount = 1.5;
      scale = scale === 1 ? magnifyAmount : 1;
      applyTransform();
    }
    
    function applyTransform() {
      const image = document.getElementById('mainImage');
      image.style.transform = `scale(${scale}) rotate(${rotateDeg}deg) ${flipped ? 'scaleX(-1)' : ''}`;
    }

    const fullScreen = (event) => {
      event.preventDefault();
      if(fullscreenFlag)
      {
        document.exitFullscreen();
        fullscreenFlag = false;
      }
      else{
        document.documentElement.requestFullscreen();
        fullscreenFlag = true;
      }
    };

    const resetImage = (event) => {
      event.preventDefault();
      
      //const image = document.getElementById('mainImage');
      //image.src = jpgPath;
      
      scale = 1;
      rotateDeg = 0;
      flipped = false;
      
      applyTransform();

      const image = document.getElementById('mainImage');
      image.style.filter = 'none';
    };

    const openImage = (event, i) => {
      event.preventDefault();
      
      if(myWindowJPG === null){
        myWindow = window.open(jpgPath, "mytsoftdicom-jpg");
      }
      else
      {
        if(myWindowJPG.closed){
          myWindowJPG = window.open(jpgPath, "mytsoftdicom-jpg");
        }
        else
        {
          myWindowJPG.location.href = jpgPath;
        }
      } 
    };

    const showImage = (event, i) => {
      event.preventDefault();
      
      setJpgPath(patientFilesData[i].file_name);
      
      const image = document.getElementById('mainImage');
      image.src = patientFilesData[i].file_name;
    };
    
    const showImageArea = (event) => {
      if(event!=null){
        event.preventDefault();
      }

      if(showImageAreaFlag === true && showReportAreaFlag === false)
      {
          return;
      };

      if(showImageAreaFlag)
      {
        showImageAreaFlag = false;
        
        const thumnailarea = document.getElementById('thumnailarea');
        thumnailarea.style.display='none';

        const imgarea = document.getElementById('imgarea');
        imgarea.style.display='none';

        const reportarea = document.getElementById('reportarea');
        reportarea.classList.remove("icol-7");
        reportarea.classList.add("icol-12");
      }
      else{
        
        const thumnailarea = document.getElementById('thumnailarea');
        thumnailarea.style.display='';

        const imgarea = document.getElementById('imgarea');
        imgarea.style.display='';

        const reportarea = document.getElementById('reportarea');
        reportarea.classList.remove("icol-12");
        reportarea.classList.add("icol-7");

        showImageAreaFlag = true;
      }
    };

    const showReportArea = (event) => {
      event.preventDefault();

      if(showImageAreaFlag === false && showReportAreaFlag === true)
      {
          return;
      };

      if(showReportAreaFlag)
      {
        const reportarea = document.getElementById('reportarea');
        reportarea.style.display='none';
        
        showReportAreaFlag = false;
      }
      else{
        
        const reportarea = document.getElementById('reportarea');
        reportarea.style.display='';

        showReportAreaFlag = true;
      }
    };

    const openNotes = (event, param, index) => {
      event.preventDefault();
      
      if(index!=null){
        setPatientIndex(index);
      }

      if(index!=null){
        document.getElementById("spnnotes_patient").innerHTML = patientData[index].patient_name;

        if(patientData[index].report_status === "F") 
        {
          document.getElementById('btnNotesSave').disabled = true;
        }
        else
        {
          document.getElementById('btnNotesSave').disabled = false;
        }

        document.getElementById("txtp_notes").value = patientData[index].notes;
        var commentsValue = patientData[index].comments;
        if(commentsValue==='' && document.getElementById("txtp_notes").value!=='')
        {
          commentsValue = document.getElementById("txtp_notes").value;
        }
        document.getElementById("divp_comments").innerHTML = commentsValue;

        document.getElementById("txtp_notes").value = '';
        document.getElementById("hidc_key_notes").value = patientData[index].center_key;
        document.getElementById("hidp_key_notes").value = patientData[index].patient_key;
      }

      if(param==='SAVE'){
        index = patientIndex;

        var action_tag = 'ADD_NOTES';
        var user_key = authUser?.user_key; 
        var report_count = 1;
        var report_content = '';
        var report_content2 = '';
        var report_content3 = '';
        var report_content4 = '';

        var notes = document.getElementById("txtp_notes").value;
        if(notes===''){
          //alert('Notes cannot be blank');
          setAutoCloseTime(autoClose5);
          notifyError('Notes cannot be blank.');
          return false;
        }

        if(patientData[index].report_status === "F")
        {
          //alert('Cannot allow to edit after printed.');
          setAutoCloseTime(autoClose5);
          notifyError('Cannot allow to edit after printed.');
          return false;
        }

        var center_key = document.getElementById("hidc_key_notes").value;
        var patient_key = document.getElementById("hidp_key_notes").value;

        if(patient_key!==patientData[index].patient_key.toString())
        {
          alert('Wrong patient details updating, refresh and try again.');
          return false;
        }

        if(center_key!==patientData[index].center_key.toString())
        {
          alert('Wrong center patient updating, refresh and try again.');
          return false;
        }

        const priority = 'N';
        updateStudy(index, action_tag, user_key, patientData[index].center_key, patientData[index].patient_key, report_count, report_content, report_content2, report_content3, report_content4, notes, '', 0, '', '', '', '', priority, '', '', '');
      }

      let modal = document.querySelector("#attachNotes");
      modal.classList.toggle("closed");
    };

    const selectPatient = (index) => {
      if(index !==null){
        patientObject.center_key=patientData[index].center_key;
        patientObject.patient_key=patientData[index].patient_key;
        patientObject.patient_id=patientData[index].patient_id;
        patientObject.patient_name=patientData[index].patient_name;
        patientObject.patient_sex=patientData[index].patient_sex;
        patientObject.patient_age=patientData[index].patient_age;
        patientObject.patient_age_unit=patientData[index].patient_age_unit;
        patientObject.report_count=patientData[index].report_count;
        patientObject.report_content=patientData[index].report_content;
        patientObject.report_content2=patientData[index].report_content2;
        patientObject.report_content3=patientData[index].report_content3;
        patientObject.report_content4=patientData[index].report_content4;
        patientObject.report_status=patientData[index].report_status;
      }
    }
    const openSubmitReport = (event, param, index, caller) => {
      if(event!=null){
        event.preventDefault();
      }
      if(authUser?.user_type !== 'D' && param === 'OPEN'){
        var objddlLineHeight = document.getElementById("ddlLineHeight");
        objddlLineHeight.selectedIndex = 0;
        setReportLineHeight(""); 
        setPrintLineHeight("");
      }

      if(index === null){
        index = patientIndex;
        if(param === 'OPEN'){
          selectPatient(index);
        }
      }

      if(authUser?.user_type === 'D'){
        if(param === 'OPEN' && caller !== 'DICOM')
        {
          ChangeStudyStatus('LOCK_PATIENT', index, null, null, null, '');
        }
        else if(param === 'CLOSE')
        {
          ChangeStudyStatus('REMOVE_LOCK', index, null, null, null, '');
        }
        else
        {
          openSubmitReportCallBack(param, index, caller);
        }
      }
      else{
        openSubmitReportCallBack(param, index, caller);
      }
    }
    const openSubmitReportCallBack = (param, index, caller) => {
      if(index!=null){
        setPatientIndex(index);
      }
      
       
      var report_count = 1;
      var report_content='';
      var report_content2 = '';
      var report_content3 = '';
      var report_content4 = '';

      /*if(authUser?.user_type !== 'D')
        {
          alert('Permission denied for the user');
          return false;
        }*/

      if(param==='OPEN'){
        openDicomJPG(authUser?.user_key, authUser?.center_key, patientData[index].patient_key);

        if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
          if(showImageAreaFlag)
          {
            showImageArea(null);
          }
        }

        /*const thumnailarea = document.getElementById('thumnailarea');
        const imgarea = document.getElementById('imgarea');

        if(patientData[index].image_total_count === 1){
          thumnailarea.style.display='none';

          imgarea.classList.remove("icol-6");
          imgarea.classList.add("icol-7");
        }
        else {
          thumnailarea.style.display='';

          imgarea.classList.remove("icol-7");
          imgarea.classList.add("icol-6");
        }*/
        
        if(authUser?.user_type === 'D'){
          document.getElementById("spnsubmit_patient").innerHTML = patientData[index].patient_name + ', Age: ' + patientData[index].patient_age.toString() + patientData[index].patient_age_unit + ', Study: ' + patientData[index].modality + '-' + patientData[index].study_description + ', History: ' + patientData[index].remarks;
        }
        else
        {
          document.getElementById("spnsubmit_patient").innerHTML = patientData[index].patient_name + ', Age: ' + patientData[index].patient_age.toString() + patientData[index].patient_age_unit;
        }
        document.getElementById("hidc_key_submit").value = patientData[index].center_key;
        document.getElementById("hidp_key_submit").value= patientData[index].patient_key;

        if(authUser?.user_type === 'D'){
          if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
            //document.getElementById('divSubmitReport').style.width = '60px';
            //document.getElementById('divSubmitReportSignedOff').style.width = '100px';
            //document.getElementById('btnSubmitReportClose').style.width = '60px';
          }
        }

        if(authUser?.user_type !== 'D'){
          document.getElementById('divSubmitReport').style.display = 'none';
          document.getElementById('divSubmitReportSignedOff').style.display = 'none';
          document.getElementById('btnreportadd').style.display = 'none';
          document.getElementById('btnreportremove').style.display = 'none';
        }
        else {
          document.getElementById('divPrintReport').style.display = 'none';
          document.getElementById('ddlLineHeight').style.display = 'none';
        }
      
        if(patientData[index].report_status === "F")
        {
          document.getElementById('btnSubmitReport').disabled = true;
          document.getElementById('btnSubmitReportSignedOff').disabled = true;
        }
        else
        {
          document.getElementById('btnSubmitReport').disabled = false;
          document.getElementById('btnSubmitReportSignedOff').disabled = false;
        }

        report_count = patientData[index].report_count;
        report_content = patientData[index].report_content;
        report_content2 = patientData[index].report_content2;
        report_content3 = patientData[index].report_content3;
        report_content4 = patientData[index].report_content4;

        document.getElementById('myReportTab').tag = report_count;
        document.getElementById('report1-tab').tag = report_content;
        document.getElementById('report2-tab').tag = report_content2;
        document.getElementById('report3-tab').tag = report_content3;
        document.getElementById('report4-tab').tag = report_content4;

        if(report_count < 4) {
          document.getElementById('report4-tab').style.display = 'none';  
        }
        else{
          document.getElementById('report4-tab').style.display = '';  
        }
        
        if(report_count < 3) {
          document.getElementById('report3-tab').style.display = 'none'; 
        }
        else{
          document.getElementById('report3-tab').style.display = '';  
        }

        if(report_count < 2) {
          document.getElementById('report2-tab').style.display = 'none'; 
        }
        else{
          document.getElementById('report2-tab').style.display = '';  
        }
        
        if(authUser?.user_type === 'D'){
          if(report_count === 1) {
            document.getElementById('btnreportremove').style.display = 'none';
          }
          else
          {
            document.getElementById('btnreportremove').style.display = '';
          }

          if(report_count === 4) {
            document.getElementById('btnreportadd').style.display = 'none';
          }
          else{
            document.getElementById('btnreportadd').style.display = '';
          }
        }
        
        document.getElementById('report4-tab').ariaSelected = false;
        document.getElementById('report3-tab').ariaSelected = false;
        document.getElementById('report2-tab').ariaSelected = false;
        document.getElementById('report1-tab').ariaSelected = true;

        document.getElementById('report4-tab').classList.remove("active");
        document.getElementById('report3-tab').classList.remove("active");
        document.getElementById('report2-tab').classList.remove("active");
        document.getElementById('report1-tab').classList.remove("active");

        document.getElementById('report1-tab').classList.add("active");
        setReportIndex(1);

        report_content = report_content.replace(/ins>/g, "u>");
        setEditorState(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(report_content))));

        setTimeout(function () {
          if(document.getElementById("hidp_key_submit").value!==patientData[index].patient_key.toString())
          {
            alert('Wrong patient details updating, refresh and try again.');
            return false; 
          }

          if(document.getElementById("hidc_key_submit").value!==patientData[index].center_key.toString())
          {
            alert('Wrong center patient updating, refresh and try again.');
            return false;
          }
        }, 1000);
      }

      if(param==='SAVE' || param=== 'SAVE_SIGNOFF' || param=== 'PRINT'){
        //alert(markupReport);
        
        index = patientIndex;

        if(param !== 'PRINT'){
          if(patientData[index].report_status === 'F')
          {
            alert('Cannot allow to edit after printed.');
            return false;
          }
        }

        var action_tag = 'REPORT_SUBMIT';
        var user_key = authUser?.user_key; 
        var notes = '';
        const priority = 'N';

        report_count = parseInt(document.getElementById("myReportTab").tag, 10);
        report_content = document.getElementById("report1-tab").tag;
        report_content2 = document.getElementById("report2-tab").tag;
        report_content3 = document.getElementById("report3-tab").tag;
        report_content4 = document.getElementById("report4-tab").tag;

        let markupReportTemp = markupReport;
        
        if(reportIndex===4){
          report_content4 = markupReportTemp;
        }
        else if(reportIndex===3){
          report_content3 = markupReportTemp;
        }
        else if(reportIndex===2){
          report_content2 = markupReportTemp;
        }
        else{
          report_content = markupReportTemp;
        }

        if(report_count > 0 && (report_content === "" || report_content === "<p></p>\n"))
        {
          alert('Report1 content cannot be blank.'); 
          return false;
        }
        if(param !== 'PRINT'){
          if(report_count > 1 && (report_content2 === "" || report_content2 === "<p></p>\n"))
          {
            alert('Report2 content cannot be blank.');
            return false;
          }
          if(report_count > 2 && (report_content3 === "" || report_content3 === "<p></p>\n"))
          {
            alert('Report3 content cannot be blank.');
            return false;
          }
          if(report_count > 3 && (report_content4 === "" || report_content4 === "<p></p>\n"))
          {
            alert('Report4 content cannot be blank.');
            return false;
          }
        }

        var center_key = document.getElementById("hidc_key_submit").value;
        var patient_key = document.getElementById("hidp_key_submit").value;
        
        if(param !== 'PRINT'){
          if(patient_key!==patientData[index].patient_key.toString())
          {
            alert('Wrong patient details updating, refresh and try again.');
            return false;
          }

          if(center_key!==patientData[index].center_key.toString())
          {
            alert('Wrong center patient updating, refresh and try again.');
            return false;
          }
        }

        report_content = reportContentAutoCorrect(report_content);
        report_content2 = reportContentAutoCorrect(report_content2);
        report_content3 = reportContentAutoCorrect(report_content3);
        report_content4 = reportContentAutoCorrect(report_content4);

        if(param === 'PRINT'){
          printReport(null, param, index, 'PRINT', 'SIGNOFF',report_count, report_content, report_content2, report_content3, report_content4);
        }
        else{
          if(param=== 'SAVE_SIGNOFF'){action_tag = 'REPORT_SUBMIT_SIGNOFF';}  /* for call openSubmitReportPreview need to comment this line */
          updateStudy(index, action_tag, user_key, patientData[index].center_key, patientData[index].patient_key, report_count, report_content, report_content2, report_content3, report_content4, notes, '', 0, '', '', '', '', priority, '', '', '');
          /*if(param=== 'SAVE_SIGNOFF'){
            setTimeout(function() {
                openSubmitReportPreview(event, 'OPEN', index, report_count, report_content, report_content2, report_content3, report_content4);
            }, 600);
          }*/
        }
      }

      if(param !== 'PRINT'){
        let modal = document.querySelector("#openSubmitReport");
        modal.classList.toggle("closed");
      }
    };

    function reportContentAutoCorrect(markupReportTemp) {
       markupReportTemp = markupReportTemp.replace(//g, '&#8226;').replace(/Ø/g, '&#8226;').replace(/●/g, '&#8226;').replace(/·/g, '&#8226;'); /*.replace('à', '&rarr;')*/
        
        if(markupReportTemp.indexOf(`\n`) > 0){
          let headerLine = markupReportTemp.slice(0, markupReportTemp.indexOf(`\n`));
          let headerLineTemp = headerLine;
          if(headerLineTemp.indexOf(`<h`) === -1){
            if(headerLineTemp.indexOf(`<p><strong>`) !== -1 
              && headerLineTemp.indexOf(`</strong></p>`) !== -1){
              headerLineTemp = headerLineTemp.replace(`<p><strong>`, `<h2><strong>`);
              headerLineTemp = headerLineTemp.replace(`</strong></p>`, `</strong></h2>`);
            }
          }
          markupReportTemp = markupReportTemp.replace(headerLine, headerLineTemp);
        }

        return markupReportTemp;
    }
    const openSubmitReportPreview = (event, param, index, report_count, report_content, report_content2, report_content3, report_content4) => {
      event.preventDefault();
      
      if(index!=null){
        setPatientIndex(index);
      }
      
      if(authUser?.user_type !== 'D')
        {
          alert('Permission denied for the user');
          return false;
        }

      if(param==='OPEN'){        
        document.getElementById("spnsubmit_patient_preview").innerHTML = patientData[index].patient_name + '(' + patientData[index].modality + '-' + patientData[index].study_description + ')';

        document.getElementById("hidc_key_submit_preview").value = patientData[index].center_key;
        document.getElementById("hidp_key_submit_preview").value= patientData[index].patient_key;

        if(patientData[index].report_status === "F")
        {
          document.getElementById('btnSubmitReportSignedOffPreview').disabled = true;
        }
        else
        {
          document.getElementById('btnSubmitReportSignedOffPreview').disabled = false;
        }

        document.getElementById('hidreport_count').value = report_count;
        document.getElementById('hidreport1-tab').value = report_content;
        document.getElementById('hidreport2-tab').value = report_content2;
        document.getElementById('hidreport3-tab').value = report_content3;
        document.getElementById('hidreport4-tab').value = report_content4;

        const template = getReportContent(index, report_count, report_content, report_content2, report_content3, report_content4, 'PRINT', '');
        let templatePreview = template.replace('report_template3.css', 'report_template3_preview.css');
        templatePreview = templatePreview.replace(' class ="bodytext">', ' class ="bodytext"> <br/><br/><br/><br/><br/><br/><br/>');
         
        document.getElementById('divPreviewContent').innerHTML = templatePreview;

        var WinPrintPreview = window.open('', '', 'width=850,height=600');
        WinPrintPreview.document.write(template);
        WinPrintPreview.document.close();
        WinPrintPreview.focus();
        
        setTimeout(function() {
          WinPrintPreview.print();
          WinPrintPreview.close();
        }, 600);

      }

      if(param==='SAVE_SIGNOFF_SUBMIT'){
        index = patientIndex;

        if(patientData[index].report_status === "F")
        {
          alert('Cannot allow to edit after printed.');
          return false;
        }

        var action_tag = 'REPORT_SUBMIT';
        var user_key = authUser?.user_key; 
        var notes = '';
        const priority = 'N';

        report_count = parseInt(document.getElementById("hidreport_count").value, 10);
        report_content = document.getElementById("hidreport1-tab").value;
        report_content2 = document.getElementById("hidreport2-tab").value;
        report_content3 = document.getElementById("hidreport3-tab").value;
        report_content4 = document.getElementById("hidreport4-tab").value;

        if(report_count === 0)
        {
          alert('Report1 content cannot be blank.'); 
          return false;
        }
        
        var center_key = document.getElementById("hidc_key_submit_preview").value;
        var patient_key = document.getElementById("hidp_key_submit_preview").value;

        if(patient_key!==patientData[index].patient_key.toString())
        {
          alert('Wrong patient details updating, refresh and try again.');
          return false;
        }

        if(center_key!==patientData[index].center_key.toString())
        {
          alert('Wrong center patient updating, refresh and try again.');
          return false;
        }

        action_tag = 'REPORT_SUBMIT_SIGNOFF';
        updateStudy(index, action_tag, user_key, patientData[index].center_key, patientData[index].patient_key, report_count, report_content, report_content2, report_content3, report_content4, notes, '', 0, '', '', '', '', priority, '', '', '');
      }

      let modal = document.querySelector("#openSubmitReportPreview");
      modal.classList.toggle("closed");
    };

    const getReportContent = (index, report_count, report_content, report_content2, report_content3, report_content4, action_type, caller) =>
    {
      if(action_type==='' || action_type === null){
        action_type = 'PRINT';
      }

      var dr_sign_position = `right`;
      if (patientData[index].center_key === 56){
        dr_sign_position = `left`;
      }

      var report_hdr_align = ``;
      if (patientData[index].center_key === 58){
        report_hdr_align = `center`;
      }

      //var reportTemplate="<p>Patient Name: "+patientData[index].patient_name+". &nbsp;&nbsp;&nbsp;&nbsp; Study Date/Time: "+patientData[index].regn_date + patientData[index].regn_time +"<br>Sex/Age/Modality: "+patientData[index].patient_sex + patientData[index].patient_age + patientData[index].modality + " &nbsp;&nbsp;&nbsp;&nbsp; Report Date/Time: "+patientData[index].updated_on+"<br>Patient ID: "+patientData[index].patient_id+" &nbsp;&nbsp;&nbsp;&nbsp; Report: CHEST PA<br>Ref. Physician: "+patientData[index].refer_physician+" Report ID: " + patientData[index].report_id;

      report_content= report_content.replace('<h1>', '<h2>').replace('</h1>', '</h2>').replace('à', '&rarr;').replace(//g, '&#8226;').replace(/Ø/g, '&#8226;');
      report_content2= report_content2.replace('<h1>', '<h2>').replace('</h1>', '</h2>').replace('à', '&rarr;').replace(//g, '&#8226;').replace(/Ø/g, '&#8226;');
      report_content3= report_content3.replace('<h1>', '<h2>').replace('</h1>', '</h2>').replace('à', '&rarr;').replace(//g, '&#8226;').replace(/Ø/g, '&#8226;');
      report_content4= report_content4.replace('<h1>', '<h2>').replace('</h1>', '</h2>').replace('à', '&rarr;').replace(//g, '&#8226;').replace(/Ø/g, '&#8226;');

      if(report_hdr_align === `center1`)
      {
        report_content= report_content.replace('<h2>', '<h2>').replace('</h2>', '</h2>');
        report_content2= report_content2.replace('<h2>', '<h2>').replace('</h2>', '</h2>');
        report_content3= report_content3.replace('<h2>', '<h2>').replace('</h2>', '</h2>');
        report_content4= report_content4.replace('<h2>', '<h2>').replace('</h2>', '</h2>');
      }

      var report_template_code = authUser?.report_template_code.toString();
      var topMarginHeader = authUser?.header_margin.toString(); //'150';
      var bottomMarginFooter = authUser?.footer_margin.toString();//'120';
      var topMarginBodyArea = authUser?.header_bodyarea.toString();//'300';
      var bottomMarginBodyArea = authUser?.footer_bodyarea.toString();//'300';

      //topMarginHeader = '100'; bottomMarginFooter = '100'; topMarginBodyArea = '250'; bottomMarginBodyArea = '250';
      //topMarginHeader = '80'; bottomMarginFooter = '80'; topMarginBodyArea = '230'; bottomMarginBodyArea = '230';
      
      //report_template_code = 'Template4';
      //report_template_code = '';
      const urlRoot = `${process.env.REACT_APP_API_URL_EC2}`;
      //alert(urlRoot); 
      const modality = patientData[index].modality;
      let cssReportName = 'css/report_template3.css';
      let cssReportLinkRef1 = ``;
      if (modality === 'CT' || modality === 'ct' || report_template_code === 'CT')
      {
        cssReportName = 'css/report_template_ct.css';
        cssReportLinkRef1 = `<link rel="preconnect" href="https://fonts.googleapis.com">
          <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
          <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700;900&display=swap" rel="stylesheet">`;
      }
      else if(report_template_code === 'Template4'){
        cssReportName = 'css/report_template4.css';
        cssReportLinkRef1 = `<link href="https://fonts.googleapis.com/css2?family=Dancing+Script:wght@500&family=Roboto:wght@500;700;900&display=swap" rel="stylesheet">`;
      }
      
      var template3 = ``;
      var sign_url_data = 'profile/dr-diptendu_sign.jpg';
      var dr_name = 'Dr. Diptendu Kumar Biswas';
      var dr_design = 'M.B.B.S., D.M.R.D. (Consultant Radiologist)';
      var dr_regn = 'Registration No: 61828 [WBMC]';

      if(patientData[index].doctor_key === 108 || patientData[index].doctor_key === 111)
      {
        sign_url_data = 'profile/108_dr_sign.jpg';
        dr_name = 'Dr. Bidhan Chandra Sarkar';
        dr_design = 'M.B.B.S. DMRD M.D. [Consultant Radiologist]';
        dr_regn = 'Registration No. : 53091 [WBMC]';
      }
      else if (patientData[index].center_key === 49
        || patientData[index].center_key === 14
        || patientData[index].center_key === 50
        || patientData[index].center_key === 52
        || (patientData[index].center_key >= 61 && patientData[index].center_key <= 64)
        || (patientData[index].patient_key > 19090 &&
            (patientData[index].center_key === 16
              || patientData[index].center_key === 40
              || patientData[index].center_key === 42
              )
            ) 
            || (patientData[index].patient_key > 23610 && patientData[index].center_key === 41)
            || (patientData[index].doctor_key === 78 && patientData[index].center_key === 31)
            || (patientData[index].doctor_key === 78 && patientData[index].center_key === 68)
            || (patientData[index].doctor_key === 78 && 
                  (patientData[index].center_key === 33 || patientData[index].center_key === 66
                    || patientData[index].center_key === 18)
                )
            || (patientData[index].doctor_key === 78 && patientData[index].center_key === 59)
            || (patientData[index].doctor_key === 78 && patientData[index].center_key > 69)
            || (patientData[index].doctor_key === 78 && patientData[index].center_key === 53 && patientData[index].patient_key > 58775)
            || (patientData[index].doctor_key === 78 && patientData[index].center_key === 56 && patientData[index].patient_key > 58775)
            || (patientData[index].doctor_key === 78 && patientData[index].center_key === 60 && patientData[index].patient_key > 58775)
        )
      {
        sign_url_data = 'profile/78-dr-asif_sign.jpg';
        dr_name = 'Dr. Sk Md Asif Iquebal';
        dr_design = 'MD (Radio-Diagnosis)';
        dr_regn = 'Reg. No.-71264 (WBMC)';
      }

      if(action_type === 'RTF') {
        report_content = report_content.replace(/ins>/g, "u>");
        if(report_content2!== ''){
          report_content2 = report_content2.replace(/ins>/g, "u>");
          report_content2 = '<br/><br/>'+report_content2;
        }
        if(report_content3!== ''){
          report_content3 = report_content3.replace(/ins>/g, "u>");
          report_content3 = '<br/><br/>'+report_content3;
        }
        if(report_content4!== ''){
          report_content4 = report_content4.replace(/ins>/g, "u>");
          report_content4 = '<br/><br/>'+report_content4;
        }

        //var fontawesomemin = urlRoot+'/'+'css/font-awesome.min.css';
        //cssReportName = urlRoot+'/'+cssReportName;
        //<link href="`+fontawesomemin+`" rel="stylesheet">
        //`+cssReportLinkRef1+`

        //sign_url_data =`data:image/jpeg;base64,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`;
        sign_url_data = 'https://tele.mytsofts.com/' + sign_url_data;
        template3 = `<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'>
                      <head><meta charset='utf-8'>
                      <title>`+patientData[index].patient_name + `-` + patientData[index].patient_id +`</title>
                      <style rel="stylesheet">
                    body{
                        font-family: 'Arial','Times New Roman', Times, serif;
                    }
                    table {
                        font-family: arial, sans-serif;
                        border-collapse: collapse;
                        width: 100%;
                      }
                      
                      td, th {
                        text-align: left;
                        padding:8px;
                      }
                      p {
                        font-family:Arial, Helvetica, sans-serif;
                        font-size: 16px;  
                        font-weight: 400;                      
                        }
                        
                    .topheader{
                        font-family:Arial, Helvetica, sans-serif;
                        padding: 5px 10px;
                    }
                    .tab-container{
                        background: #f1f1f1;
                        border-radius: 15px;
                        border: #4e4e4e 2px solid;
                        padding: 20px 10px;
                    }
                    .rptname{
                        font-family: 'Dancing Script', cursive;
                        background: #d7d7d7;
                        border-radius: 10px;
                        padding: 12px 18px;
                        top: -10px;
                        position: relative;
                    }
                    .row{
                        --bs-gutter-x: 1.5rem;
                        --bs-gutter-y: 0;
                        display: flex;
                        flex-wrap: wrap;
                        margin-top: calc(-1 * var(--bs-gutter-y));
                        margin-right: calc(-0.5 * var(--bs-gutter-x));
                        margin-left: calc(-0.5 * var(--bs-gutter-x));
                    }
                    .col-3{ 
                        flex: 0 0 auto;
                        width: 25%;
                        font-weight: 400;
                    }
                    .col-30{ 
                        flex: 0 0 auto;
                        width: 30%;
                        font-weight: 400;
                    }
                    .col-40{ 
                        flex: 0 0 auto;
                        width: 40%;
                        font-weight: 400;
                    }
                    .col-20{ 
                        flex: 0 0 auto;
                        width: 20%;
                        font-weight: 400;
                    }
                    .col-10{ 
                        flex: 0 0 auto;
                        width: 10%;
                        font-weight: 400;
                    }
                    .col-6{ 
                        flex: 0 0 auto;
                        width: 50%;
                        font-weight: 400;
                    }
                    .col-12{ 
                        flex: 0 0 auto;
                        width: 100%;
                        font-weight: 400;
                    }
                    .headertext{
                        font-size:16px;
                        font-weight:400;
                        padding: 5px 20px;
                    }
                    .headertext_bold{
                        font-weight:700;
                    }
                    
                    .bodytext{
                        font-weight:400;
                        padding: 5px 10px;
                    }
                    
                    .bodytextlast{
                        font-weight:400;
                        padding: 5px 10px;
                    }
                    
                    .font20{
                        font-size: 20px;
                    }
                    .font30{
                        font-size: 30px;
                    }
                    .text-center{
                        text-align: center;
                    }
                    .bold{
                        font-weight:700;
                    }
                    .italic{
                        font-style: italic;
                    }
                    .bold_italic{
                        font-weight:700;
                        font-style: italic;
                    }
                    .italic_underline{
                        font-style: italic;
                        text-decoration: underline;
                    }
                    .underline{
                        text-decoration: underline;
                    }
                    .bold_underline{
                        font-weight:700;
                        text-decoration: underline;
                    }
                    .bold_italic_underline{
                        font-weight:700;
                        font-style: italic;
                        text-decoration: underline;
                    }
                    
                    footer{
                        margin-top: auto;
                        bottom: 10px;
                        width: 100%;
                    }
                    .footer_text{
                        font-size: 10px;
                        font-weight: 400;
                        padding: 10px 0;
                        margin-top: 10px;
                        border-top: #000 1px solid;
                        border-bottom: #000 1px solid;
                    }
                    .footer_text span{
                        font-size: 10px;
                        font-weight: 700;
                    }
                    .footsign{
                        font-size: 14px;
                        font-weight: 400;
                        padding: 5px 22px;
                        text-align: center;
                    }
                    .footsign span{
                        font-size: 18px;
                        font-weight: 500;
                    }
                    .float-right{
                        float: right;
                    }
                    .float-left{
                        float: left;
                    }
                    .me-2{
                        margin-right: 2em;
                    }
                    .mw-2{
                        margin-left: 2em;
                    }
                    .margin-auto{ margin:auto;}
                    
                    .divFooter{
                        font-family:Arial, Helvetica, sans-serif;
                        padding: 20px 0 0 0;
                    }
                    
                    
                    @media print {
                        .topheader{
                            position: fixed;
                            top: 50px;
                            font-size: 14px;
                        }
                        .bodyarea{
                            position: relative;
                            height:180px;
                        }
                        .bodytext{ height: 180px;}
                        .bodytext { page-break-after: always; }
                        .divFooter {
                            padding: 20px 0 0 0;
                            position: fixed;
                        }
                    
                    }
                      </style>
                      </head>
                      <body>`;
        
      }
      else
      {
        template3 = `<!DOCTYPE html>
        <html lang="en">
        <head>
            <meta charset="UTF-8">
            <meta http-equiv="X-UA-Compatible" content="IE=edge">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <title>`+patientData[index].patient_name + `-` + patientData[index].patient_id +`</title>
            <link href="css/font-awesome.min.css" rel="stylesheet">
            `+cssReportLinkRef1+`
            <link href="`+cssReportName+`" rel="stylesheet">
        </head>
        <body>`;
      }

      let patient_age_unit = ``;
      
      if (report_template_code === 'Template4')
      {
        if(patientData[index].patient_age_unit==='Y'){
          patient_age_unit = ' Year';
        }
        else if(patientData[index].patient_age_unit==='M'){
          patient_age_unit = ' Month';
        }
        else if(patientData[index].patient_age_unit==='D'){
          patient_age_unit = ' Day';
        }

        if(patient_age_unit !== '' && patientData[index].patient_age>1){
          patient_age_unit += 's';
        }
      }
      else{
        patient_age_unit = patientData[index].patient_age_unit;
      }
      
      let patient_age_print = patientData[index].patient_age;
      var patient_age_tmp = patient_age_print.toString().split(`.`);
      if( patient_age_tmp.length>1){
        patient_age_print = patient_age_tmp[0] + patient_age_unit + ` ` + patient_age_tmp[1];

        if (report_template_code === 'Template4' && 1===2)
        {
          if(patientData[index].patient_age_unit==='Y'){
            patient_age_print += ' Month';
          }
          else if(patientData[index].patient_age_unit==='M'){
            patient_age_print += ' Day';
          }

          if((patientData[index].patient_age_unit==='Y' || patientData[index].patient_age_unit==='M') && parseFloat(patient_age_tmp[1]) >1){
            patient_age_print += 's';
          }
        }
        else
        {
          if(patientData[index].patient_age_unit==='Y'){
            patient_age_print += 'M';
          }
          else if(patientData[index].patient_age_unit==='M'){
            patient_age_print += 'D';
          }
        }
      }
      else
      {
        patient_age_print += patient_age_unit;
      }

      let patient_sex = '';
      if(patientData[index].patient_sex==='M'){
        patient_sex = 'Male';
      }
      else if(patientData[index].patient_sex==='F'){
        patient_sex = 'Female';
      }
      let patient_id = '';
      if (patientData[index].center_key !== 18){
        patient_id = patientData[index].patient_id;
      }
      
      var bodyTextCustomStyle = "";

      if(caller === 'SIGNOFF'){
        if(printLineHeight !== ""){
          
          bodyTextCustomStyle = "line-height:" + printLineHeight + ";";
        }
      }

      let reportHeader = ``;
      if (modality === 'CT' || modality === 'ct' || report_template_code === 'CT')
      {
        reportHeader =`<thead>
                        <tr>
                          <th style="width:130px;border: 1px solid #000;">Name</td>
                          <th style="width:300px;border: 1px solid #000;">`+patientData[index].patient_name+`</td>
                          <th style="width:100px;border: 1px solid #000;">Age/Sex</td>
                          <th style="width:150px;border: 1px solid #000;">`+patient_age_print+`-`+patientData[index].patient_sex+`</td>
                        </tr>
                        <tr>
                          <th style="border: 1px solid #000;">Date</td>
                          <th style="border: 1px solid #000;">`+patientData[index].regn_date+`</td>
                          <th style="border: 1px solid #000;">Patient Id</td>
                          <th style="border: 1px solid #000;">`+patientData[index].patient_id_ref+`</td>
                        </tr>
                        <tr>
                          <th style="border: 1px solid #000;">Referring Doctor</td>
                          <th style="border: 1px solid #000;">`+patientData[index].refer_physician+`</td>
                          <th style="border: 1px solid #000;">Report Id</td>
                          <th style="border: 1px solid #000;">`+patientData[index].patient_id+`</td>
                        </tr>
                      </thead>`;
      }
      else if (report_template_code === 'Template4')
      {
        reportHeader =`<div class ="topheader" style="margin-top: `+ topMarginHeader + `px;">
                      <div class ="tab-container">
                          <table style="width: 900px">
                              <tr>
                              <td style="width:150px;"><i class ="fa fa-user-o" aria-hidden="true"></i> Patient</td>
                              <td style="width:400px;"><i class ="fa fa-caret-right iconcol" aria-hidden="true"></i>&nbsp; <b>`+patientData[index].patient_name+`</b></td>
                              <td style="width:150px;"><i class ="fa fa-venus-mars" aria-hidden="true"></i> Age</td>
                              <td style="width:200px;"><i class ="fa fa-caret-right iconcol" aria-hidden="true"></i>&nbsp; <b>`+patient_age_print+`</b></td>
                              </tr>
                              <tr>
                              <td><i class ="fa fa-refresh" aria-hidden="true"></i> Ref By</td>
                              <td><i class ="fa fa-caret-right iconcol" aria-hidden="true"></i>&nbsp; <b>`+patientData[index].refer_physician+`</b></td>
                              <td><i class ="fa fa-venus" aria-hidden="true"></i> Gender</td>
                              <td><i class ="fa fa-caret-right iconcol" aria-hidden="true"></i>&nbsp; <b>`+patient_sex+`</b></td>
                              </tr>
                              <tr>
                              <td><i class ="fa fa-clock-o" aria-hidden="true"></i> Date</td>
                              <td><i class ="fa fa-caret-right iconcol" aria-hidden="true"></i>&nbsp; <b>`+patientData[index].regn_date+`</b></td>
                              <td><i class ="fa fa-file-text" aria-hidden="true"></i> Report Id</td>
                              <td><i class ="fa fa-caret-right iconcol" aria-hidden="true"></i>&nbsp; <b>`+patient_id+`</b></td>
                              </tr>
                          </table>
                      </div>
                  </div>`;
      }
      else{
        var col1_width = '130';
        var col2_width = '300';
        var col3_width = '100';
        var col4_width = '150';

        if(patientData[index].center_key === 39)
        {
          col2_width = '255';
          col3_width = '80';
          col4_width = '215';
        }

        reportHeader = `<div class ="topheader" style="margin-top: `+ topMarginHeader + `px;">
                      <table style="width: 680px;">
                          <tr>
                            <td style="width:`+col1_width+`px;border: 1px solid #000;">Name</td>
                            <td style="width:`+col2_width+`px;border: 1px solid #000;">`+patientData[index].patient_name+`</td>
                            <td style="width:`+col3_width+`px;border: 1px solid #000;">Age/Sex</td>
                            <td style="width:`+col4_width+`px;border: 1px solid #000;">`+patient_age_print+`-`+patientData[index].patient_sex+`</td>
                          </tr>
                          <tr>
                            <td style="border: 1px solid #000;">Date</td>
                            <td style="border: 1px solid #000;">`+patientData[index].regn_date+`</td>
                            <td style="border: 1px solid #000;">Patient Id</td>
                            <td style="border: 1px solid #000;">`+patientData[index].patient_id_ref+`</td>
                          </tr>
                            <tr>
                            <td style="border: 1px solid #000;">Referring Doctor</td>
                            <td style="border: 1px solid #000;">`+patientData[index].refer_physician+`</td>
                            <td style="border: 1px solid #000;">Report Id</td>
                            <td style="border: 1px solid #000;">`+patientData[index].patient_id+`</td>
                          </tr>
                      </table>
                  </div>`;
      }

      var qrCodeValueinnerHTML = '';
      if (modality === 'CT' || modality === 'ct' || report_template_code === 'CT' 
        || patientData[index].center_key === 68 || patientData[index].center_key === 61 
        || patientData[index].center_key === 59 || patientData[index].center_key === 54 
        || patientData[index].center_key === 33 || patientData[index].center_key === 66 
        || patientData[index].center_key === 39 || patientData[index].center_key === 58
        || patientData[index].center_key === 14 
      )
      {
        var qrCodeValue = document.getElementById(`qrCode_`+patientData[index].patient_key);
        if(qrCodeValue!==null){
          qrCodeValueinnerHTML = qrCodeValue.innerHTML;
        }
      }
      var qrCodeDisplay = '';
      if(qrCodeValueinnerHTML===''){
        qrCodeDisplay = 'none';
      }
      
      if (modality === 'CT' || modality === 'ct' || report_template_code === 'CT')
      {
        for(var iCnt = 0; iCnt<report_count; iCnt++){
          let reportValue = report_content;
          let pageBreakClass = 'bodytext';
          if(iCnt === report_count-1){
            pageBreakClass = '';
          }

          if(iCnt===1){
            reportValue = report_content2;
          }
          else if(iCnt===2){
            reportValue = report_content3;
          }
          else if(iCnt===3){
            reportValue = report_content4;
          }

          template3 += 
          `<div class ="container `+pageBreakClass+`">
            <table id="report">`
              +reportHeader +`
              <tbody class ="report-body">
                <tr style="height:20px;"><td colspan="4"></tr>
                <tr>
                  <td colspan="4">` 
                    + reportValue
                    + `
                  </td>
                </tr>

                <tr><td colspan="4"><br/><br/></tr>

                <tr>
                  <td colspan="4">
                    <div class ="row">
                      <table style="width: 100%; border:none;">
                        <tr>
                          <td style="width:44%;">
                            <div class ="margin-auto">
                                <div class ="footsign" style="height:auto; width: 85px; background-color:lightgrey; padding:3px 3px 0px 3px;display:`+qrCodeDisplay+`;">
                                  `+ qrCodeValueinnerHTML +`
                                </div>
                            </div>
                          </td>
                          <td>
                            <div>
                              <div class ="footsign">
                                  <img src="`+ sign_url_data +`" width="229" height="48" /><br/>
                                  <span><b>`+ dr_name +`</b></span> <br/>
                                  `+ dr_design +`<br/>
                                  `+ dr_regn +` <br/>
                              </div>
                            </div>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </td>
                </tr>

                <tr>
                  <td colspan="4">
                    <div class ="footer_text" style="font-size:9px; line-height: 10px;">
                        <span style="font-size:12px;"><b>Disclaimer:</b></span> It is an online interpretation of medical imaging based on clinical data. All modern machines
                        /procedures have their own limitation. If there is any clinical discrepancy this investigation may be repeated
                        or reassessed by other tests. Patient’s identification in online reporting is not established, So in no way can
                        this report be utilized for any medico legal purpose.
                    </div>
                  
                  </td>
                </tr>

              </tbody>

              <tfoot class ="report-footer">
                <tr>
                    <th colspan="4" style="width:250px;bottom: `+ bottomMarginFooter + `px;">
                        &nbsp;
                    </th>
                </tr>
              </tfoot>
            </table>
          </div>`;
        }
        
        template3 += `
        </body>
        </html>`;
      }
      else{
        let reportFooter = ``;
        let footerBottom = 'Y';
        let footerDisclaimerText = '';

        let disclaimerFontSize = '9px';
        if(report_template_code === 'Template4'){
          disclaimerFontSize = '10px';
        }

        if(patientData[index].center_key === 33 
          || patientData[index].center_key === 66
          ){
            ;
        }
        else {
          footerDisclaimerText = `
            <div class ="row">
              <table style="width: 100%; border:none;">
                <tr>
                  <td style="width:100%;">
                    <div class ="margin-auto">
                        <div class ="footsign" style="font-size:`+disclaimerFontSize+`; line-height: 10px; text-align:left;">
                          <span style="font-size:12px;"><b>Disclaimer:</b></span> It is an online interpretation of medical imaging based on clinical data. All modern machines
                          /procedures have their own limitation. If there is any clinical discrepancy this investigation may be repeated
                          or reassessed by other tests. Patient’s identification in online reporting is not established, So in no way can
                          this report be utilized for any medico legal purpose.
                        </div>
                    </div>
                  </td>
                </tr>
              </table>
            </div>`;
        }

        if(patientData[index].center_key === 18 || patientData[index].center_key === 42)
        {
          footerBottom = 'N';
        }

        if(dr_sign_position===`left`){
          if (footerBottom === 'Y')
          {
            reportFooter += `
            <footer class ="divFooter" style="bottom: `+ bottomMarginFooter + `px;">`;
          }
          else
          {
            reportFooter += `
            <footer>`;
          }
          reportFooter += `
              <div class ="row">
                  <table style="width: 100%; border:none;">
                    <tr>
                      <td>
                        <div>
                          <div class ="footsign">
                              <img src="`+ sign_url_data +`" width="229" height="48" /><br/>
                              <span><b>`+ dr_name +`</b></span> <br/>
                              `+ dr_design +`<br/>
                              `+ dr_regn +` <br/>
                          </div>
                        </div>
                      </td>
                      <td style="width:44%;">
                        <div class ="margin-auto">
                            <div class ="footsign" style="height:auto; width: 85px; background-color:lightgrey; padding:3px 3px 0px 3px;display:`+qrCodeDisplay+`;">
                              `+ qrCodeValueinnerHTML +`
                            </div>
                        </div>
                      </td>
                    </tr>
                  </table>
              </div>`;

          reportFooter += footerDisclaimerText + `
            </footer>`;
        }
        else{
          if (footerBottom === 'Y')
          {
            reportFooter += `
            <footer class ="divFooter" style="bottom: `+ bottomMarginFooter + `px;">`;
          }
          else
          {
            reportFooter += `
            <footer>`;
          }
          reportFooter += `
                <div class ="row">
                    <table style="width: 100%; border:none;">
                      <tr>
                        <td style="width:44%;">
                          <div class ="margin-auto">
                              <div class ="footsign" style="height:auto; width: 85px; background-color:lightgrey; padding:3px 3px 0px 3px;display:`+qrCodeDisplay+`;">
                                `+ qrCodeValueinnerHTML +`
                              </div>
                          </div>
                        </td>
                        <td>
                          <div>
                            <div class ="footsign">
                                <img src="`+ sign_url_data +`" width="229" height="48" /><br/>
                                <span><b>`+ dr_name +`</b></span> <br/>
                                `+ dr_design +`<br/>
                                `+ dr_regn +` <br/>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </table>
                </div>`;

          reportFooter += footerDisclaimerText + `
            </footer>`;
        }
      
        template3 += reportHeader + `<div class ="bodyarea" style="top: `+ topMarginBodyArea + `px; bottom: `+ bottomMarginBodyArea + `px;">`;

        template3 += `<div`;
        if(report_count > 1){
        template3 += ` class ="bodytext" style="`+ bodyTextCustomStyle + `">`;
        }
        else{
        template3 += ` class ="bodytextlast" style="`+ bodyTextCustomStyle + `">`;
        }

        if (report_template_code === 'Template4')
        {
          template3 +=`<center class ="mb-1"><span class ="text-center font30 rptname">Radiological Observation</span></center>`;
        }

        template3 += report_content;
        if (footerBottom === 'N')
        {
          template3 += reportFooter;
        }

        template3 += `</div>`;

        if(report_count > 1 && report_content2 !== '')
        {
          if (report_template_code === 'Template4')
          {
            template3 += reportHeader + `<div class ="bodyarea" style="top: `+ topMarginBodyArea + `px; bottom: `+ bottomMarginBodyArea + `px;">`;
          }

        template3 += `<div`;
        if(report_count > 2){
          template3 += ` class ="bodytext" style="`+ bodyTextCustomStyle + `">`;
        }
        else{
          template3 += ` class ="bodytextlast" style="`+ bodyTextCustomStyle + `">`;
        }

        if (report_template_code === 'Template4')
        {
          template3 +=`<center class ="mb-1"><span class ="text-center font30 rptname">Radiological Observation</span></center>`;
        }

        template3 += report_content2;
        if (footerBottom === 'N')
        {
          template3 += reportFooter;
        }

        template3 += `</div>`;
        }

        if(report_count > 2 && report_content3 !== '')
        {
          if (report_template_code === 'Template4')
          {
            template3 += reportHeader + `<div class ="bodyarea" style="top: `+ topMarginBodyArea + `px; bottom: `+ bottomMarginBodyArea + `px;">`;
          }
          
        template3 += `<div`;
        if(report_count > 3){
          template3 += ` class ="bodytext" style="`+ bodyTextCustomStyle + `">`;
        }
        else{
          template3 += ` class ="bodytextlast" style="`+ bodyTextCustomStyle + `">`;
        }

        if (report_template_code === 'Template4')
        {
          template3 +=`<center class ="mb-1"><span class ="text-center font30 rptname">Radiological Observation</span></center>`;
        }

        template3 += report_content3;
        if (footerBottom === 'N')
        {
          template3 += reportFooter;
        }

        template3 += `</div>`;
        }

        if(report_count > 3 && report_content4 !== '')
        {
          if (report_template_code === 'Template4')
          {
            template3 += reportHeader + `<div class ="bodyarea" style="top: `+ topMarginBodyArea + `px; bottom: `+ bottomMarginBodyArea + `px;">`;
          }
          
        template3 += `<div`;
        if(report_count > 4){
          template3 += ` class ="bodytextlast" style="`+ bodyTextCustomStyle + `">`;
        }
        else{
          template3 += ` class ="bodytextlast" style="`+ bodyTextCustomStyle + `">`;
        }

        if (report_template_code === 'Template4')
        {
          template3 +=`<center class ="mb-1"><span class ="text-center font30 rptname">Radiological Observation</span></center>`;
        }

        template3 += report_content4;
        if (footerBottom === 'N')
        {
          template3 += reportFooter;
        }

        template3 += `</div>`;
        }
        template3 += `</div>`;
        
        if (footerBottom === 'Y')
        {
          template3 += reportFooter;
        }
        
        template3 += `</body></html>`;
      }
      return template3;
    }
    const printReport = (event, param, index, action_type, caller, report_count, report_content, report_content2, report_content3, report_content4) => {
      if(caller !== 'SIGNOFF'){
        event.preventDefault();
      }

      if(index!=null){
        setPatientIndex(index);
      }
      //alert(index); alert(index);
      if(index!=null){
        //alert(markupReport);
        //alert(patientData[index].report_content);

        if(report_count===null || report_count === undefined)
        {
          report_count = patientData[index].report_count;
          report_content= patientData[index].report_content;
          report_content2= patientData[index].report_content2;
          report_content3= patientData[index].report_content3;
          report_content4= patientData[index].report_content4;
        }

        if(caller === 'SIGNOFF')
        {
          if(report_count === 4)
          {
            if(report_content4 === "" || report_content4 === "<p></p>\n"
              || report_content4 === "<h1></h1>\n"
              || report_content4 === "<h2></h2>\n"
              || report_content4 === "<h3></h3>\n")
            {
              report_content4 = ""; report_count = 3;
            }
          }

          if(report_count === 3)
          {
            if(report_content3 === "" || report_content3 === "<p></p>\n"
              || report_content3 === "<h1></h1>\n"
              || report_content3 === "<h2></h2>\n"
              || report_content3 === "<h3></h3>\n")
            {
              report_content3 = ""; report_count = 2;
            }
          }

          if(report_count === 2)
          {
            if(report_content2 === "" || report_content2 === "<p></p>\n"
              || report_content2 === "<h1></h1>\n"
              || report_content2 === "<h2></h2>\n"
              || report_content2 === "<h3></h3>\n")
            {
              report_content2 = ""; report_count = 1;
            }
          }

        }

        if(report_count === 0 || (report_content === "" || report_content === "<p></p>\n" 
          || report_content === "<h1></h1>\n" || report_content === "<h2></h2>\n"))
        {
          alert('Report content is empty and not yet submitted.'); 
          return false;
        }

        if(patientData[index].report_status !== 'S' && patientData[index].report_status !== 'F')
        {
          alert('Report is not yet signed off.'); 
          return false;
        }

        if(patientData[index].patient_sex === '')
        {
          alert('Patient sex is blank, cannot allow to print.'); 
          return false;
        }
        if(patientData[index].patient_age === '' || patientData[index].patient_age === '0' || patientData[index].patient_age === 0)
        {
          alert('Patient age is blank, cannot allow to print.'); 
          return false;
        }

        const template = getReportContent(index, report_count, report_content, report_content2, report_content3, report_content4, action_type, caller);
        if(action_type==='RTF')
        {
          ExportToDoc(template, patientData[index].patient_id +'-'+ patientData[index].patient_name.replace('&', '-'));
          patientData[index].notes = 'EXPORT_RTF_STUDY';
          ChangeStudyStatus('PRINT_STUDY', index, null, patientData[index].center_key, patientData[index].patient_key, '');
        }
        else {
          var WinPrint = window.open('', '', 'width=850,height=600');
          WinPrint.document.write(template);
          WinPrint.document.close();
          WinPrint.focus();

          setTimeout(function() {
              WinPrint.print();
              if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
                setTimeout(function() {
                  WinPrint.close();
                }, 30000);
              }
              else{
                WinPrint.close();
              }
          }, 600);

          if(caller !== 'SIGNOFF'){
          ChangeStudyStatus('PRINT_STUDY', index, null, patientData[index].center_key, patientData[index].patient_key, '');
          }
        }
        
      }
      
    };

    function ExportToDoc(elementValue, filename = ''){
      var html = elementValue;   
      var blob = new Blob(['\ufeff', html], {
          type: 'application/msword'
      });
      
      // Specify link url
      var url = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(html);
      
      // Specify file name
      filename = filename?filename+'.rtf':'document.rtf';
      
      // Create download link element
      var downloadLink = document.createElement("a");
   
      document.body.appendChild(downloadLink);
      
      if(navigator.msSaveOrOpenBlob ){
          navigator.msSaveOrOpenBlob(blob, filename);
      }else{
          // Create a link to the file
          downloadLink.href = url;
          
          // Setting the file name
          downloadLink.download = filename;
          
          //triggering the function
          downloadLink.click();
      }
      
      document.body.removeChild(downloadLink);
    }

    const openActivityLog = (event, param, index, action_tag) => {
      event.preventDefault();
      
      if(index!=null){
        setPatientIndex(index);
      }

      if(param === 'OPEN'){
        document.getElementById("spnlog_patient").innerHTML = patientData[index].patient_id + ' ' + patientData[index].patient_name;
        
        if (!authUser) return null;

        const url = `${process.env.REACT_APP_API_URL}/activitylog`;
  
        const user_key = authUser?.user_key;
        const center_key = authUser?.center_key;
        const patient_key = patientData[index].patient_key;

        const request_id = randomNumberInRange(1000000, 9000000);
        const token = JSON.parse(localStorage.getItem('user')).token;
        const action_tag = "";
        const config = {
          headers: {
            'content-type': 'application/json',
            'Authorization': `Bearer ${token}`,
            'user_key': user_key.toString(),
            'center_key': center_key.toString(),
            'patient_key': patient_key.toString(),
            'action_tag': action_tag,
            'request_id': request_id.toString()
          },
        };
    
        try {
          
          setActivitylogData([]); 

          axios.get(url, config).then((response) => { 
            let updatedValue = {};
            if(response.data.length>0){
              updatedValue = response.data; 
            }
           
           setActivitylogData(updatedValue); 
          })
          
        .catch(error => {
          var Unauthorized = false; var errorCatch = '';
          if(error.response!= null)
          {
            errorCatch = 'Exception found!';
            if(error.response.data != null)
            {
              if(error.response.data.message==='Unauthorized')
              {
                Unauthorized = true;
              }
              else
              {
                errorCatch = error.response.data.message;
              }
            }
          }
          else if(error.message!= null)
          {
            errorCatch = error.message;
          }

          if(Unauthorized)
          {
            alert('Unauthorized session, try to relogin.');
            logout();
          }
          else{
            alert(errorCatch);
          }
         });
        } catch (err) {
          //debugger;
          //alert('error');
            //alert(err.code);
          if (err.code === '404') {
            //setError('Object does not exist.')
            return
          }
        }

      }

      let modal = document.querySelector("#activityLog");
      modal.classList.toggle("closed");
    };

    const openModal2 = (event, param) => {
      event.preventDefault();

      let modal2 = document.querySelector("#modal2");
      modal2.classList.toggle("closed");
    };
    
    const openContactInfo = (event, param, i) => {
      event.preventDefault();

      let modal3 = document.querySelector("#modal3");
      modal3.classList.toggle("closed");
    };
    
    const openModalSuccess = (event, param) => {
      event.preventDefault();

      let modal4 = document.querySelector("#modal_success");
      modal4.classList.toggle("closed");
    };
    const openModalError = (event, param) => {
      event.preventDefault();

      let modal5 = document.querySelector("#modal_error");
      modal5.classList.toggle("closed");
    };
    
    const viewDicom = (event, dicomUrl, index, objectType, viewerName) => {
      event.preventDefault();

      if(authUser?.user_type !== 'D')
        {
          if(objectType==='div'){
            return false;  
          }

          if(viewerName!='ohif'){
            alert('Permission denied for the user');
            return false;
          }
        }
 
      if(prev_dicomobj!=null){
        //prev_dicomobj.classList.remove("bi-eye-slash");
        //prev_dicomobj.classList.add("bi-eye-fill");
      }

      var dicomobj = document.getElementById("btndicom_"+index.toString());
      if(dicomobj!=null){
        //dicomobj.classList.remove("bi-eye-fill");
        //dicomobj.classList.add("bi-eye-slash");
      }

      if(prev_dicomobj === null || prev_dicomobj !== dicomobj){
        prev_dicomobj = dicomobj;
      }

      if(authUser?.user_type !== 'D' && viewerName === 'ohif'){
        openDicomViewer(patientData[index].patient_key, patientData[index].study_key, patientData[index].instance_uid, patientData[index].modality, patientData[index].image_total_count, dicomUrl, viewerName);
      }
      else{
        ChangeStudyStatus('LOCK_DICOM', index, dicomUrl, null, null, viewerName);
      }
    };
    
    const NotificationPending = () => {
      if (pendingCount > 0){
        return <span className="badge notification-badge rounded-pill badge-primary">{pendingCount}</span>;
      }
      else
      {
        return null;
      }
    }

    const NotificationWaiting = () => {
      if (waitingCount > 0){
        return <span className="badge notification-badge rounded-pill badge-notification bg-dark">{waitingCount}</span>;
      }
      else
      {
        return null;
      }
    }
    const NotificationHold = () => {
      if (holdCount > 0){
        return <span className="badge notification-badge rounded-pill badge-notification bg-dark">{holdCount}</span>;
      }
      else
      {
        return null;
      }
    }
    const NotificationDraft = () => {
      if (draftCount > 0){
        return <span className="badge notification-badge rounded-pill badge-notification">{draftCount}</span>;
      }
      else
      {
        return null;
      }
    }
    const NotificationSignedoff = () => {
      if (signedoffCount > 0){
        return <span className="badge notification-badge rounded-pill badge-notification bg-warning">{signedoffCount}</span>;
      }
      else
      {
        return null;
      }
    }
    const NotificationUrgent = () => {
      if (urgentCount > 0){
        return <span className="badge notification-badge rounded-pill badge-notification bg-danger" title="Count Only Pending Status">{urgentCount}</span>
      }
      else
      {
        return null;
      }
    }

    const EncryptPatientKey = (data) => {
      var CryptoJS = require("crypto-js");
      var ciphertext = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(data));
      return encodeURIComponent(ciphertext);
    }

    return (
        <div className="tele-body">
            
            <main>
                    <div className="container-fluid px-4">
                        <div className="row">
                          {/*<div className="col-md-7 mt-2">
                            <h5 className="text-blue font-roboto font-weight700">Study List</h5>
                          </div>
                          */}
                          
                          <div className="col-12 col-lg-7 col-md-7 mt-2">
                            <ul className="nav nav-tabs" id="myTab" role="tablist">
                              <li className="nav-item" role="presentation">
                                <button className="nav-link padd-right-navtab notification active" id="pending-tab" data-bs-toggle="tab" data-bs-target="#pending-tab-pane" type="button" role="tab" aria-controls="pending-tab-pane" aria-selected="true" onClick={event => tabClick('P', 'A') }><small><b>Pending </b></small>
                                {NotificationPending()}
                                </button>
                              </li>
                              {(waitingCount > 0  ? 
                                  <li className="nav-item" role="presentation">
                                    <button className="nav-link padd-right-navtab notification" id="waiting-tab" data-bs-toggle="tab" data-bs-target="#waiting-tab-pane" type="button" role="tab" aria-controls="waiting-tab-pane" aria-selected="false" onClick={event => tabClick('PW', 'A') }><small><b>Waiting </b></small>
                                    {NotificationWaiting()}
                                    </button>
                                  </li>
                                : <span></span>
                              )}
                              
                              {(holdCount > 0  ? 
                                  <li className="nav-item" role="presentation">
                                    <button className="nav-link padd-right-navtab notification" id="hold-tab" data-bs-toggle="tab" data-bs-target="#hold-tab-pane" type="button" role="tab" aria-controls="hold-tab-pane" aria-selected="false" onClick={event => tabClick('PH', 'A') }><small><b>On-Hold </b></small>
                                    {NotificationHold()}
                                    </button>
                                  </li>
                                : <span></span>
                              )}
                              
                              {(draftCount > 0  ? 
                                  <li className="nav-item" role="presentation">
                                    <button className="nav-link padd-right-navtab notification" id="draft-tab" data-bs-toggle="tab" data-bs-target="#draft-tab-pane" type="button" role="tab" aria-controls="draft-tab-pane" aria-selected="false" onClick={event => tabClick('PD', 'A') }><small><b>Draft </b></small>
                                    {NotificationDraft()}
                                    </button>
                                  </li>
                                : <span></span>
                              )}
                              
                              <li className="nav-item" role="presentation">
                                <button className="nav-link padd-right-navtab notification" id="signedoff-tab" data-bs-toggle="tab" data-bs-target="#signedoff-tab-pane" type="button" role="tab" aria-controls="signedoff-tab-pane" aria-selected="false" onClick={event => tabClick('S', 'A') }><small><b>Signed Off </b></small>
                                {NotificationSignedoff()}
                                </button>
                              </li>
                              <li className="nav-item" role="presentation">
                                <button className="nav-link padd-right-navtab notification" id="printed-tab" data-bs-toggle="tab" data-bs-target="#signedoff-tab-pane" type="button" role="tab" aria-controls="signedoff-tab-pane" aria-selected="false" onClick={event => tabClick('F', 'A') }><small><b>Printed </b></small>
                                </button>
                              </li>
                              {(urgentCount > 0 ? 
                                  <li className="nav-item" role="presentation">
                                    <button className="nav-link padd-right-navtab notification" id="urgent-tab" data-bs-toggle="tab" data-bs-target="#urgent-tab-pane" type="button" role="tab" aria-controls="urgent-tab-pane" aria-selected="false" onClick={event => tabClick('A', 'Y') }><small><b>Urgent </b></small>
                                    {NotificationUrgent()}
                                    </button>
                                  </li>
                                : <span></span>
                              )}
                              
                              {(authUser?.user_type === 'A' || authUser?.user_type === 'U' ? 
                                  <li className="nav-item" role="presentation">
                                    <button className="nav-link notification" id="deactivated-tab" data-bs-toggle="tab" data-bs-target="#deactivated-tab-pane" type="button" role="tab" aria-controls="deactivated-tab-pane" aria-selected="false" onClick={event => tabClick('X', 'A') }><small><b>Deactivated </b></small>
                                    </button>
                                  </li>
                                : <span></span>
                              )}
                              <li className="nav-item" role="presentation">
                                <button className="nav-link notification" id="all-tab" data-bs-toggle="tab" data-bs-target="#all-tab-pane" type="button" role="tab" aria-controls="all-tab-pane" aria-selected="false" onClick={event => tabClick('A', 'A') }><small><b>All </b></small>
                                </button>
                              </li>
                              <div className="nav-item" id="divLoading"> processing...</div>
                            </ul>
                          </div>

                          <div className="col-md-4">
                            <nav aria-label="Page navigation" className="mt-2">
                            <ul className="pagination pagination-sm justify-content-end">
                              <li className="page-item disabled" id="pageFirst">
                                <a className="page-link" href=" #" onClick={event => pageClick(1)}><i className="bi bi-arrow-left" title="First Page"></i></a>
                              </li>
                              <li className="page-item disabled" id="pagePrev">
                                <a className="page-link" href=" #" onClick={event => pagePrev()}><i className="bi bi-caret-left-fill" title="Previous Page"></i></a>
                              </li>
                              <li className="page-item active"><a className="page-link" href=" #" id="lnkpageno1" onClick={event => pageClick(1)}>1</a></li>
                              <li className="page-item"><a className="page-link" href=" #" id="lnkpageno2" onClick={event => pageClick(2)}>2</a></li>
                              <li className="page-item"><a className="page-link" href=" #" id="lnkpageno3" onClick={event => pageClick(3)}>3</a></li>
                              <li className="page-item disabled"><a className="page-link" href=" #" id="lnkpagenomore">...</a></li>
                              <li className="page-item"><a className="page-link" href=" #" id="lnkpagenoLast" onClick={event => pageClick(0)}>4</a></li>
                              <li className="page-item" id="pageNext">
                                <a className="page-link" href=" #" onClick={event => pageNext()}><i className="bi bi-caret-right-fill" title="Next Page"></i></a>
                              </li>
                              <li className="page-item" id="pageLast">
                                <a className="page-link" href=" #" onClick={event => pageClick(0)}><i className="bi bi-arrow-right" title="Last Page"></i></a>
                              </li>
                              <li><input type="page" className="form-control form-control-sm width60 height30" id="txtpage_no_s" placeholder="1 of 1" /></li>
                              <li><button type="button" className="btn btn-tele btn-sm" id="btnpagesearch" value="0" onClick={event => pageSearch()}><i className="bi bi-arrow-right-square"></i></button></li>
                            </ul>
                          </nav>
                          </div>
                          <div className="col-md-1 mt-2">
                            {/* Pagination */}
                            <select className="form-select form-select-sm" id="ddlpage_size_s" name="sellist1" onChange={event => pageSizeChange(null, true)}>
                              <option>10</option>
                              <option>25</option>
                              <option>50</option>
                              <option>100</option>{/**/}
                            </select>
                          </div>
                        </div>

                        <hr className="mt-0" />

                        <div className="row">
                            <div className="col-md-12 mb-2">
                                <div className="card">
                                    <div className="card-header bg-gradient-1 text-light">
                                      {/* Table Heading */}
                                      <div className="row">
                                        <div className="col-3 col-sm-1 col-md-1">
                                          <p className="tele-table-heading"><i className="bi bi-arrow-up" onClick={event => sortClick(event, 'patient_id') }></i> Id </p>
                                          <input type="text" className="form-control form-control-sm tele-table-searcharea" id="patient_id" onChange={handleSearchChange} placeholder="" />
                                        </div>
                                        <div className="col-5 col-sm-2 col-md-2">
                                          <p className="tele-table-heading"><i className="bi bi-arrow-down icon-muted" onClick={event => sortClick(event, 'patient_name') }></i>Patient </p>
                                          <input type="text" className="form-control form-control-sm tele-table-searcharea" id="patient_name" onChange={handleSearchChange} placeholder="" />
                                        </div>
                                        <div className="col-4 col-sm-2 col-md-2">
                                          <p className="tele-table-heading"><i className="bi bi-arrow-up icon-muted" onClick={event => sortClick(event, 'regn_date') }></i>Date/History </p>
                                          <input type="date" className="form-control form-control-sm tele-table-searcharea" id="regn_date" onChange={handleSearchChange} />
                                        </div>
                                        <div className="col-4 col-sm-2 col-md-2 d-none d-sm-block" >
                                          <p className="tele-table-heading"><i className="bi bi-arrow-down icon-muted" onClick={event => sortClick(event, 'modality') }></i>Study </p>
                                          <input type="text" className="form-control form-control-sm tele-table-searcharea" id="modality" onChange={handleSearchChange} placeholder="" />
                                        </div>
                                        <div className="col-sm-1 col-md-1 d-none d-md-none d-lg-none">
                                          <p className="tele-table-heading"><i className="bi bi-arrow-down icon-muted" onClick={event => sortClick(event, 'refer_physician') }></i>Referral </p>
                                          <input type="text" className="form-control form-control-sm tele-table-searcharea" id="refer_physician" onChange={handleSearchChange} placeholder="" />
                                        </div>
                                        <div className="col-sm-1 col-md-1 d-none d-sm-block">
                                          <p className="tele-table-heading"><i className="bi bi-arrow-down icon-muted" onClick={event => sortClick(event, 'report_status_desc') }></i>Status </p>
                                          <input type="text" className="form-control form-control-sm tele-table-searcharea" id="report_status_desc" onChange={handleSearchChange} placeholder="" />
                                        </div>
                                        <div className="col-sm-2 col-md-2 d-none d-sm-block"><p className="tele-table-heading">Process</p></div>
                                        <div className="col-sm-1 col-md-1 d-none d-md-none d-lg-none">
                                          <p className="tele-table-heading"><i className="bi bi-arrow-down icon-muted" onClick={event => sortClick(event, 'center_name') }></i>Center </p>
                                          <input type="text" className="form-control form-control-sm tele-table-searcharea" id="center_name" onChange={handleSearchChange} placeholder="" />
                                        </div>
                                        
                                        <div className="col-sm-1 col-md-1 d-none d-md-none d-lg-none d-sm-block"><p className="tele-table-heading">Report</p></div>
                                        <div className="col-sm-2 col-md-2 d-none d-sm-block"><p className="tele-table-heading">Action</p></div>
                                      </div>
                                    </div>
                                    <div className="card-body tele-table-padding studylist-area">
                                        {/* tele-table-rowbg1 */}
                                        <div className="row studylist" id="divStatusResult">
                                        </div>

                                        {Object.keys(patientData).map((data, i) => (
                                          <div key={i} className="row studylist" onDoubleClick={event => viewDicom(event, patientData[i].dicom_path, i, 'div', '')}>
                                          
                                          {(authUser?.user_type === 'A' ? 
                                                  <div className="col-3 col-sm-1 col-md-1">
                                                    <p className="tele-table-text float-left">
                                                    <div>{patientData[i].patient_id}</div>
                                                    <span title={patientData[i].center_id + ': ' + patientData[i].center_name}>{patientData[i].center_id}</span>
                                                    </p>
                                                  </div>
                                                : <div className="col-3 col-sm-1 col-md-1"><p className="tele-table-text float-left">{patientData[i].patient_id}</p></div>
                                          )}
                                          
                                          <div className="col-5 col-sm-2 col-md-2">
                                            <p className="tele-table-text">
                                              {(patientData[i].priority === 'Y' && (search_priority !== 'Y' || patientData[i].report_status === 'P') ? 
                                                  <font color='#e51b48'>{patientData[i].patient_name}<br/></font>
                                                : <div>{patientData[i].patient_name}</div>
                                              )}
                                            <span>{patientData[i].patient_id_ref}, ({patientData[i].patient_sex}), {patientData[i].patient_age}{patientData[i].patient_age_unit}</span></p>
                                          </div>

                                          <div className="col-4 col-sm-2 col-md-2">
                                            <p className="tele-table-text">{patientData[i].regn_date} &nbsp;
                                            <span>{patientData[i].regn_time}</span> <br/>
                                            <span title={patientData[i].remarks}>{patientData[i].remarks.substring(0, 20)}</span>
                                            </p>
                                          </div>

                                          <div className="col-8 col-sm-2 col-md-2">
                                            <p className="tele-table-text">{patientData[i].modality} - {patientData[i].study_description} <br/>
                                            <span>
                                              {patientData[i].body_part}, {patientData[i].fileupload_status}
                                            </span></p>
                                          </div>
                                          <div className="col-sm-1 col-md-1 d-none d-md-none d-lg-none"><p className="tele-table-text">Hospital</p></div>
                                          <div className="col-4 col-sm-1 col-md-1"><p className="tele-table-text">
                                              {(patientData[i].priority === 'Y' && (search_priority !== 'Y' || patientData[i].report_status === 'P') ? 
                                                  <div><font color='#e51b48'>{patientData[i].report_status_desc}</font></div>
                                                : <div>{patientData[i].report_status_desc}</div>
                                              )}
                                            </p>
                                          </div>
                                          <div className="col-8 col-sm-2 col-md-2">
                                            
                                            {(patientData[i].attach_file_count > 0 ? 
                                                  <span className="badge badge-notification1">{patientData[i].attach_file_count}</span>
                                                : <span></span>
                                            )}
                                            <button type="button" className="btn btn-outline-warning btn-sm bi bi-pencil-fill" title="Edit Study" onClick={event => openEditStudy(event, 'OPEN', i)}>
                                            </button>

                                            {(patientData[i].notes !== '' ? 
                                                  (patientData[i].updated_by === authUser?.user_key ? 
                                                    <button type="button" className="btn btn-outline-warning btn-sm bi bi-bookmarks-fill m-1" title={patientData[i].notes} onClick={event => openNotes(event, 'OPEN', i)}>
                                                    </button>
                                                  : 
                                                    <button type="button" className="btn btn-warning btn-sm bi bi-bookmarks-fill m-1" title={patientData[i].notes} onClick={event => openNotes(event, 'OPEN', i)}>
                                                    </button>
                                                  )
                                                : 
                                                <button type="button" className="btn btn-outline-warning btn-sm bi bi-bookmarks m-1" title="Empty notes" onClick={event => openNotes(event, 'OPEN', i)}>
                                                </button>
                                            )}
                                            
                                            
                                            {(authUser?.user_type === 'D' || ((patientData[i].report_status === 'S' || patientData[i].report_status === 'F') && (authUser?.user_type === 'A' || authUser?.user_key === 1 || authUser?.user_key === 26 || authUser?.user_key === 41 || authUser?.user_key === 100  || authUser?.user_key === 39 || authUser?.user_key === 48 || authUser?.user_key === 82 || authUser?.user_key === 89 || authUser?.user_key === 94 || authUser?.user_key === 17 || authUser?.user_key === 18 || authUser?.user_key === 21)) ? 
                                                  <button type="button" className="btn btn-outline-warning btn-sm bi bi-check-square"  title="Submit Report" onClick={event => openSubmitReport(event, 'OPEN', i, '')}></button>
                                                : <span></span>
                                            )}

                                            {(authUser?.user_type === 'D' ? 
                                                  <span style={{display:"none"}}></span>
                                                : 
                                                (patientData[i].report_status === 'P' || patientData[i].report_status === 'X' ? 
                                                  <button type="button" className="btn btn-outline-warning btn-sm bi bi-printer" title="Report not yet ready" onClick={event => printReport(event, 'OPEN', i, 'PRINT', '')}></button>
                                                : 
                                                  (authUser?.user_key === 1 || authUser?.user_key === 26 || authUser?.user_key === 41 || authUser?.user_key === 39 ? 
                                                    <span>
                                                      <button type="button" className="btn btn-outline-warning btn-sm bi bi-printer-fill m-1" title="Print Report" onClick={event => printReport(event, 'OPEN', i, 'PRINT', '')}></button>
                                                    </span>
                                                  : 
                                                  <button type="button" className="btn btn-outline-warning btn-sm bi bi-printer-fill m-1" title="Print Report" onClick={event => printReport(event, 'OPEN', i, 'PRINT', '')}></button>
                                                  )
                                                )
                                            )}

                                            {(authUser?.user_type === 'A' || authUser?.user_type === 'S' ? 
                                                  <button id={`btnCopyClip_${patientData[i].patient_key.toString()}`} type="button" className="btn btn-outline-warning btn-sm bi bi-clipboard m-1" title="Copy to clipboard" onClick={event => copyClipboard(event, i, patientData[i].patient_key)}></button>
                                                : 
                                                <span style={{display:"none"}}></span>
                                            )}

                                            {(patientData[i].modality === 'CT' 
                                            || patientData[i].center_key === 14 
                                            || patientData[i].center_key === 68 || patientData[i].center_key === 61 
                                            || patientData[i].center_key === 59 || patientData[i].center_key === 54
                                            || patientData[i].center_key === 33 || patientData[i].center_key === 66 
                                            || patientData[i].center_key === 39 || patientData[i].center_key === 58 ? 
                                                  <div id={`qrCode_${patientData[i].patient_key.toString()}`} style={{ height: "auto", margin: "0 auto", maxWidth: 64, width: "100%", display: "none" }}>
                                                    <QRCode
                                                    size={256}
                                                    style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                                                    value={`https://tele.mytsofts.com/qrcodereport?data=${EncryptPatientKey(patientData[i].center_key.toString() + '~' + patientData[i].patient_key.toString())}`}
                                                    viewBox={`0 0 256 256`}
                                                    />
                                                </div>
                                                : <span></span>
                                            )}

                                          </div>
                                          <div className="col-sm-2 col-md-2 d-none d-md-none d-lg-none"><p className="tele-table-text">Center</p></div>
                                          
                                          <div className="col-sm-1 col-md-1 d-none d-md-none d-lg-none"><p className="tele-table-text">Report 1</p></div>
                                          <div className="col-4 col-sm-2 col-md-2">
                                            {(authUser?.user_type === 'D' ? 
                                                  <button type="button" className="btn btn-outline-warning btn-sm2 bi bi-eye-fill" title="View DICOM" id={"btndicom_"+i.toString()} onClick={event => viewDicom(event, patientData[i].dicom_path, i, 'button', '')}></button>
                                                : <span style={{display:"none"}}></span>
                                            )}
                                            
                                            {((patientData[i].modality !== 'CT' && (authUser?.user_type === 'A' || authUser?.user_type === 'D' || authUser?.user_key === 100 || authUser?.user_key === 17 || authUser?.user_key === 94)) ? 
                                                  <button type="button" className="btn btn-outline-warning btn-sm2 bi bi-display m-1" title="OHIF DICOM Viewer" id={"btndicomOHIF_"+i.toString()} onClick={event => viewDicom(event, patientData[i].dicom_path, i, 'button', 'ohif')}></button>
                                                : <span style={{display:"none"}}></span>
                                            )}
                                            
                                            {(authUser?.user_type === 'A' && patientData[i].report_status === 'P' && patientData[i].report_content === '' ? 
                                                  <button type="button" className="btn btn-outline-warning btn-sm2 bi bi-person-check" title="Assign Doctor" onClick={event => openAssignDoctor(event, 'OPEN', i)}></button>
                                                : <span>
                                                  {(patientData[i].report_status === 'F'? 
                                                        <button type="button" className="btn btn-outline-warning btn-sm2 bi bi-arrow-counterclockwise" title="Rework study" onClick={event => ChangeStudyStatus('REWORK_STUDY', i, null, null, null, '')}></button>
                                                      : 
                                                        <button type="button" className="btn btn-outline-warning btn-sm2 bi bi-lock-fill"  title="Unlock study" onClick={event => ChangeStudyStatus('UNLOCK_STUDY', i, null, null, null, '')}></button>
                                                  )}
                                                </span>
                                            )}

                                            {/*
                                            {<button type="button" className="btn btn-outline-warning btn-sm bi bi-cloud-arrow-down-fill m-1" title="Download zip" onClick={event => openModalSuccess(event, 'OPEN')}></button>
                                            */}
                                            
                                            {(authUser?.user_type === 'D' || authUser?.user_type === 'A' ? 
                                                  <button id={`btnActivityLog_${patientData[i].patient_key.toString()}`} type="button" className="btn btn-outline-warning btn-sm2 bi bi-activity m-1" style={{ display: "inline" }} title="Activity Log" onClick={event => openActivityLog(event, 'OPEN', i, null)}></button>
                                                : <span></span>
                                            )}

                                            
                                            {(authUser?.user_type === 'S' || authUser?.user_type === 'A' ? 
                                                  <button id={`btnCopyStudy_${patientData[i].patient_key.toString()}`} type="button" className="btn btn-outline-warning btn-sm2 bi bi-file-break" title="Copy study" onClick={event => ChangeStudyStatus('COPY_STUDY', i, null, null, null, '')}></button>
                                                : <span></span>
                                            )}

                                            {(authUser?.user_type === 'A' || authUser?.user_type === 'S' ? 
                                                  <span style={{display:"none"}}></span>
                                                : 
                                                <button id={`btnCopyClip_${patientData[i].patient_key.toString()}`} type="button" className="btn btn-outline-warning btn-sm2 bi bi-clipboard m-1" title="Copy to clipboard" onClick={event => copyClipboard(event, i, patientData[i].patient_key)}></button>
                                            )}
                                          
                                            {(authUser?.user_type === 'D' || authUser?.user_type === 'A' || authUser?.user_type === 'S' ? 
                                                  <span style={{display:"none"}}></span>
                                                : 
                                                (authUser?.user_key === 1 || authUser?.user_key === 26 || authUser?.user_key === 41 || authUser?.user_key === 39 ? 
                                                  <button type="button" className="btn btn-outline-warning btn-sm2 bi bi-wordpress" title="Export Report to RTF" onClick={event => printReport(event, 'OPEN', i, 'RTF', '')}></button>
                                                : 
                                                  <span style={{display:"none"}}></span>
                                                )
                                            )}

                                          </div>
                                          </div>
                                          
                                        ))}
                                        
                                        
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </main>
        
        
        {/*<!-- Custom Modal -->*/}
        <div id="modal" className="modal closed">

            {/*<!-- Modal content -->*/}
            <div className="editstudy-modal-content">
                <div className="modal-header pt-2">
                    <span className="close" id="close-button" onClick={event => openEditStudy(event, 'CLOSE', null)}>&times;</span>
                    <h6 className="mb-0"><i className="bi bi-person-circle"></i> Patient Details: <span id="spnedit_patient"></span></h6>
                </div>
                <div className="modal-body">
                  {/*<!-- justify-content-center -->*/}
                    <div className="row ">
                        <div className="col-lg-2 col-6 pe-1">
                            <div className="input-group input-group-sm mt-2">
                                <div className="input-group-prepend"><span className="input-group-text input-sm">
                                        <small>ID</small></span></div> <input type="text" placeholder="Patient ID"
                                    required="required" className="form-control"
                                    id="txtp_id" readOnly />
                                    <input type="hidden" id="hidc_key" />
                                    <input type="hidden" id="hidp_key" />
                            </div>
                        </div>
                        <div className="col-lg-4 col-6 ps-1 pe-1">
                            <div className="input-group input-group-sm mt-2">
                                <div className="input-group-prepend"><span className="input-group-text input-sm">
                                        <small>Name</small></span></div> <input type="text" placeholder="Name"
                                    required="required" className="form-control"
                                    id="txtp_name" />
                            </div>
                        </div>
                        <div className="col-lg-3 col-12 ps-1 pe-1">
                            <div className="input-group input-group-sm mt-2">
                                <div className="input-group-prepend"><span className="input-group-text input-sm">
                                        <small>Age</small></span></div> <input type="text" placeholder="Age"
                                    required="required" className="form-control"
                                    id="txtage" />
                                    <select
                                      className="form-select form-select-sm"
                                      aria-label=".form-select-sm example"
                                      name="patient_age_unit"
                                      id="ddlage_unit"
                                    >
                                      <option value="Y">Years</option>
                                      <option value="M">Months</option>
                                      <option value="D">Days</option>
                                    </select>
                            </div>
                        </div>
                        <div className="col-lg-3 col-12 ps-1 pe-1">
                            <div className="input-group input-group-sm mt-2">
                                <div className="input-group-prepend"><span className="input-group-text input-sm">
                                        <small>Gender</small></span></div> <input type="text" placeholder="Gender"
                                    required="required" className="form-control"
                                    id="txtgender" />
                            </div>
                        </div>

                        <div className="col-lg-6 col-12 ps-1 pe-1">
                            <div className="input-group input-group-sm mt-2">
                                <div className="input-group-prepend"><span className="input-group-text input-sm">
                                        <small>Reference ID:</small></span></div> <input type="text" placeholder="Reference ID"
                                    required="required" className="form-control"
                                    id="txtp_id_ref" />
                            </div>
                        </div>

                        <div className="col-lg-1 col-12 ps-1 pe-1">
                            <div className="input-group input-group-sm mt-2">
                                <div className="input-group-prepend"><span className="input-group-text input-sm">
                                        <small>Urgent &nbsp;</small>
                                        <input type="checkbox" placeholder="Urgent" title="Priority" id="chkurgent" />
                                        </span></div> 
                            </div>
                        </div>

                        <div className="col-lg-6 col-12 ps-1 pe-1">
                            <div className="input-group input-group-sm mt-2">
                                <div className="input-group-prepend"><span className="input-group-text input-sm">
                                        <small>Study Name:</small></span></div> <input type="text" placeholder="Study Name"
                                    required="required" className="form-control"
                                    id="txtstudyname" />
                            </div>
                        </div>
                        <div className="col-lg-6 col-12 ps-1 pe-1">
                            <div className="input-group input-group-sm mt-2">
                                <div className="input-group-prepend"><span className="input-group-text input-sm">
                                        <small>Referring Physician Name:</small></span></div> <input type="text" placeholder="Physician"
                                    required="required" className="form-control"
                                    id="txtphysician_name" />
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center pb-3">
                        <div className="col-lg-12 col-12 ps-1 pe-1">
                            <div className="form-group mt-2">
                                <label for="" className="font-size14">Add History:</label>
                                <textarea className="form-control font-size14" rows="4" id="txthistory"></textarea>
                            </div>
                        </div>
                    </div>
                    
                    <div className="row justify-content-center pb-1">
                      <div className="col-lg-12 col-md-12 mb-2">
                        
                          <div>
                            Upload History Images:
                            <input type="hidden" id="hidattachcount"></input>
                            <input type="hidden" id="hidattachjson"></input>
                          </div>
                            
                              
                              <div className="col-12 report-bg">
                                <div className="row mt-3">
                                  <div className="col-1">
                                    <a href=" #" title="prev">
                                      <div style={divStyle1}>
                                        <i className="bi bi-caret-left-fill"></i>
                                      </div>
                                    </a>
                                  </div>
                                  <div className="col-10" style={divStyle2}>
                                    <output className="row" id="attachFileResult"></output>
                                  </div>
                                  <div className="col-1">
                                    <a href=" #" title="next">
                                      <div style={divStyle3}>
                                        <i className="bi bi-caret-right-fill"></i>
                                      </div>
                                    </a>
                                  </div>
                                </div>
                              </div>
                        
                      </div>
                    </div>
                    <div className="row justify-content-center pb-0">
                        <div className="col-4 text-left pl-2">
                          <label htmlFor="historyFiles">
                            <small>Select files </small>
                          </label>
                          <input id="historyFiles" className="form-control-sm"
                                  type="file" multiple="multiple"
                                  onChange={handleChangeUploadFile} />
                        </div>
                        <div className="col-lg-4 col-4"><button type="button"
                                className="btn btn-secondary btn-sm btn-block bi bi-save2-fill" id="btnEditSave" onClick={event => openEditStudy(event, 'SAVE')}> SAVE</button></div>
                        <div className="col-lg-3 col-4"><button type="button"
                                className="btn btn-secondary btn-sm btn-block bi bi-x-square" id="btnEditClose" onClick={event => openEditStudy(event, 'CLOSE')}> CLOSE</button></div>
                    </div>
                </div>
            </div>
        </div>
        {/*<!--End of Custom Modal -->*/}

        {/*<!-- Assign Doctor Custom Modal -->*/}
        <div id="modalAssignDoctor" className="modal closed">

          {/*<!-- Modal content -->*/}
          <div className="assigdoctor-modal-content">
              <div className="modal-header pt-2">
                  <span className="close" id="close-button" onClick={event => openAssignDoctor(event, 'CLOSE', null)}>&times;</span>
                  <h6 className="mb-0"><i className="bi bi-person-circle"></i> Patient Details: <span id="spnassign_doctor"></span></h6>
                  <input type="hidden" id="hidc_key_assigndr" />
                  <input type="hidden" id="hidp_key_assigndr" />
                  <input type="hidden" id="hiddoctor_key" />
              </div>
              <div className="modal-body">
                  <div className="row justify-content-center pb-3">
                      <div className="col-lg-12 col-12 ps-1 pe-1">
                          <div className="form-group mt-2">
                              <label for="" className="font-size14">Search Radiologists</label>
                              <input className="form-control font-size14" id="txtdoctor_name_search"></input>
                          </div>
                      </div>
                  </div>

                  <div className="row justify-content-center pb-3">
                    {Object.keys(doctorListData).map((data, i) => (
                      <div key={i} className="row studylist">
                        <div className="col-4 col-sm-6 col-md-6">

                            {(doctorListData[i].select_flag === 'Yes' ? 
                                    <input className="form-check-input" type="radio" checked="true" name="flexRadioDefault" id={`rdoDoctor_${doctorListData[i].doctor_key.toString()}`} onClick={event => selectAssignDoctor(event, doctorListData[i].doctor_key)}  />
                                  : <input className="form-check-input" type="radio" name="flexRadioDefault" id={`rdoDoctor_${doctorListData[i].doctor_key.toString()}`} onClick={event => selectAssignDoctor(event, doctorListData[i].doctor_key)} />
                            )}

                            <label className="form-check-label" for={`rdoDoctor_${doctorListData[i].doctor_key.toString()}`}>
                            <span>&nbsp;</span>{doctorListData[i].doctor_name}
                            </label>
                          
                        </div>
                        <div className="col-4 col-sm-1 col-md-1">
                          <span>{doctorListData[i].doctor_remarks}</span>
                        </div>
                        <div className="col-4 col-sm-1 col-md-1">
                          <span>{doctorListData[i].doctor_status}</span>
                        </div>
                      </div>
                    ))}
                  </div>
              </div>

              <div className="modal-footer pt-2">
                <div className="row justify-content-center pb-0">
                    <div className="col-lg-4 col-6"><button type="button"
                            className="btn btn-secondary btn-sm btn-block bi bi-save2-fill" id="btnAssignDrSave" onClick={event => openAssignDoctor(event, 'SAVE')}> ASSIGN </button></div>
                    <div className="col-lg-4 col-6"><button type="button"
                            className="btn btn-secondary btn-sm btn-block bi bi-x-square" id="btnAssignDrClose" onClick={event => openAssignDoctor(event, 'CLOSE')}> CANCEL </button></div>
                </div>
              </div>
          </div>
        </div>
        {/*<!--End of  Assign Doctor Custom Modal -->*/}

        <div id="openSubmitReport" className="modal closed">

            {/*<!--Modal content -->*/}
            <div className="report-modal-content">
                <div className="modal-header pt-2">
                    <span className="close" onClick={event => openSubmitReport(event, 'CLOSE', null, '')}>&times;</span>
                    <h6 className="mb-0"><i className="bi bi-clipboard-check-fill"></i> Submit Report: <span id="spnsubmit_patient"></span>
                    <input type="hidden" id="hidc_key_submit" />
                    <input type="hidden" id="hidp_key_submit" />
                    </h6>
                </div>
                <div className="modal-body" style={{paddingBottom:"0rem"}}>
                  <div className="row">
                      <div className="icol-1 icol-s-12" id="thumnailarea">
                        <div className="p-1 border-rounded-crimson image-thumnail-container">
                            <div className="left-textarea border-radius-5 thumbnail_heading">
                              <p className="text-off-white">X-Ray</p>
                            </div>
                            <div className="thumbnails">
                              {Object.keys(patientFilesData).map((data, i) => ( 
                                <img key={i} src={patientFilesData[i].file_name} alt={patientFilesData[i].study_description} onClick={event => showImage(event, i)}></img>
                              ))}
                            </div>
                  
                            {/* Thumbnails for Mobile */}
                            <div className="thumbnails_mob">
                              {Object.keys(patientFilesData).map((data, i) => ( 
                                <img key={i} src={patientFilesData[i].file_name} alt={patientFilesData[i].study_description} onClick={event => showImage(event, i)}></img>
                              ))}
                            </div>
                        </div>
                      </div>
                    
                      <div className="icol-5 icol-s-12" id="imgarea">
                          <div className="header menu_dektop">
                          <div className="row">
                              <div className="icol-10 col-s-12 border-right">
                                  <div className="text-center">
                                      <button type="button" className="btn-jpg btn-blue tooltip-jpg" onClick={event => zoomIn(event)}><i className="bi bi-zoom-in"></i>
                                          <span className="tooltiptext-jpg">Zoom In</span>
                                      </button>
                                      {/* 
                                      <div className="dropdown-jpg" tabindex="1">
                                          <i className="db2-jpg" tabindex="1"></i>
                                          <a href="#" className="dropbtn-jpg"><i className="bi bi-caret-down-fill"></i></a>
                                          <div className="dropdown-content-jpg">
                                              <a href="#">Soft Tissue</a>
                                              <a href="#">Lung</a>
                                              <a href="#">Liver</a>
                                              <a href="#">Bone</a>
                                              <a href="#">Brain</a>
                                          </div>
                                      </div>
                                      */}
                                      <button type="button" className="btn-jpg btn-blue tooltip-jpg" onClick={event => zoomOut(event)}><i className="bi bi-zoom-out"></i>
                                          <span className="tooltiptext-jpg">Zoom Out</span>
                                      </button>
                                      <button type="button" className="btn-jpg btn-blue tooltip-jpg" onClick={event => rotate(event)}><i className="bi bi-arrow-clockwise"></i>
                                          <span className="tooltiptext-jpg">Rotate</span>
                                      </button>
                                      <button type="button" className="btn-jpg btn-blue tooltip-jpg" onClick={event => flip(event)}><i className="bi bi-phone-flip"></i>
                                          <span className="tooltiptext-jpg">Flip</span>
                                      </button>
                                      <button type="button" className="btn-jpg btn-blue tooltip-jpg" onClick={event => pan(event, "left")}><i className="bi bi-arrow-bar-left"></i>
                                          <span className="tooltiptext-jpg">Pan Left</span>
                                      </button>
                                      <button type="button" className="btn-jpg btn-blue tooltip-jpg" onClick={event => pan(event, "right")}><i className="bi bi-arrow-bar-right"></i>
                                          <span className="tooltiptext-jpg">Pan Right</span>
                                      </button>
                                      <button type="button" className="btn-jpg btn-blue tooltip-jpg" onClick={event => pan(event, "up")}><i className="bi bi-arrow-bar-up"></i>
                                          <span className="tooltiptext-jpg">Pan Up</span>
                                      </button>
                                      <button type="button" className="btn-jpg btn-blue tooltip-jpg" onClick={event => pan(event, "down")}><i className="bi bi-arrow-bar-down"></i>
                                          <span className="tooltiptext-jpg">Pan Down</span>
                                      </button>
                                      <button type="button" className="btn-jpg btn-blue tooltip-jpg" onClick={event => invert(event)}><i className="bi bi-mask"></i>
                                          <span className="tooltiptext-jpg">Invert Color</span>
                                      </button>
                                      <button type="button" className="btn-jpg btn-blue tooltip-jpg" onClick={event => magnify(event)}><i className="bi bi-search"></i>
                                          <span className="tooltiptext-jpg">Magnify</span>
                                      </button>
                                      <button type="button" className="btn-jpg btn-blue tooltip-jpg" id="fullscreen-btn" onClick={event => fullScreen(event)}><i className="bi bi-arrows-fullscreen"></i>
                                          <span className="tooltiptext-jpg">Toggle Fullscreen</span>
                                      </button>
                                      <button style={{display:"none"}} type="button" className="btn-jpg btn-blue tooltip-jpg"><i className="bi bi-caret-left-square"></i>
                                          <span className="tooltiptext-jpg">Previous</span>
                                      </button>
                                      <button style={{display:"none"}} type="button" className="btn-jpg btn-blue tooltip-jpg"><i className="bi bi-caret-right-square"></i>
                                          <span className="tooltiptext-jpg">Next</span>
                                      </button>
                                      <button type="button" className="btn-jpg btn-blue tooltip-jpg" onClick={event => resetImage(event)}><i className="bi bi-arrow-clockwise"></i>
                                          <span className="tooltiptext-jpg">Reset</span>
                                      </button>
                                      <button type="button" className="btn-jpg btn-blue tooltip-jpg" onClick={event => openImage(event)}><i className="bi bi-box-arrow-up-right"></i>
                                          <span className="tooltiptext-jpg">Open Image in Window</span>
                                      </button>
                                      <button className="btn-jpg btn-blue tooltip-jpg" onClick={event => showReportArea(event)}><i className="bi bi-clipboard2-data-fill"></i>
                                          <span className="tooltiptext-jpg">Show/hide Report</span>
                                      </button>

                                      <button className="btn-jpg btn-blue tooltip-jpg" onClick={event => showImageArea(event)}><i className="bi bi-card-image"></i>
                                        <span className="tooltiptext-jpg">Show/hide Image</span>
                                      </button>
                                  </div>
                              </div>
                              <div className="col-5 col-s-12">
                                  <div className="text-center">
                                      
                                      <button style={{display:"none"}} className="btn-jpg btn-blue tooltip-jpg"><i className="bi bi-bookmarks-fill"></i>
                                          <span className="tooltiptext-jpg">Notes</span> 
                                      </button>
                                  </div>
                              </div>
                          </div>
                          </div>

                          <div className="p-1 border-rounded-crimson image-container mt-1">
                              <img id="mainImage" src={jpgPath} alt="MainImage"></img>
                          </div>

                          {/* Mobile Menu Bottom */}
                          <div className="row menu_mobile">
                              <div className="icol-s-12 text-center">
                                  <div className="row menu_mobile">
                                      <div className="icol-s-12 text-center">
                                        <button type="button" className="btn-jpg btn-blue tooltip-jpg" onClick={event => zoomIn(event)}><i className="bi bi-zoom-in"></i>
                                            <span className="tooltiptext-jpg">Zoom In</span>
                                        </button>
                                        <button type="button" className="btn-jpg btn-blue tooltip-jpg" onClick={event => zoomOut(event)}><i className="bi bi-zoom-out"></i>
                                            <span className="tooltiptext-jpg">Zoom Out</span>
                                        </button>
                                        <button type="button" className="btn-jpg btn-blue tooltip-jpg" onClick={event => rotate(event)}><i className="bi bi-arrow-clockwise"></i>
                                            <span className="tooltiptext-jpg">Rotate</span>
                                        </button>
                                        <button type="button" className="btn-jpg btn-blue tooltip-jpg" onClick={event => flip(event)}><i className="bi bi-phone-flip"></i>
                                            <span className="tooltiptext-jpg">Flip</span>
                                        </button>
                                        <button type="button" className="btn-jpg btn-blue tooltip-jpg" onClick={event => pan(event, "left")}><i className="bi bi-arrow-bar-left"></i>
                                            <span className="tooltiptext-jpg">Pan Left</span>
                                        </button>
                                        <button type="button" className="btn-jpg btn-blue tooltip-jpg" onClick={event => pan(event, "right")}><i className="bi bi-arrow-bar-right"></i>
                                            <span className="tooltiptext-jpg">Pan Right</span>
                                        </button>
                                        <button type="button" className="btn-jpg btn-blue tooltip-jpg" onClick={event => pan(event, "up")}><i className="bi bi-arrow-bar-up"></i>
                                            <span className="tooltiptext-jpg">Pan Up</span>
                                        </button>
                                        <button type="button" className="btn-jpg btn-blue tooltip-jpg" onClick={event => pan(event, "down")}><i className="bi bi-arrow-bar-down"></i>
                                            <span className="tooltiptext-jpg">Pan Down</span>
                                        </button>
                                      </div>
                                      <div className="col-s-12 text-center mt-0">
                                      <button type="button" className="btn-jpg btn-blue tooltip-jpg" onClick={event => invert(event)}><i className="bi bi-mask"></i>
                                            <span className="tooltiptext-jpg">Invert Color</span>
                                        </button>
                                        <button type="button" className="btn-jpg btn-blue tooltip-jpg" onClick={event => magnify(event)}><i className="bi bi-search"></i>
                                            <span className="tooltiptext-jpg">Magnify</span>
                                        </button>
                                        <button type="button" className="btn-jpg btn-blue tooltip-jpg" id="fullscreen-btn" onClick={event => fullScreen(event)}><i className="bi bi-arrows-fullscreen"></i>
                                            <span className="tooltiptext-jpg">Toggle Fullscreen</span>
                                        </button>
                                        <button style={{display:"none"}} type="button" className="btn-jpg btn-blue tooltip-jpg"><i className="bi bi-caret-left-square"></i>
                                            <span className="tooltiptext-jpg">Previous</span>
                                        </button>
                                        <button style={{display:"none"}} type="button" className="btn-jpg btn-blue tooltip-jpg"><i className="bi bi-caret-right-square"></i>
                                            <span className="tooltiptext-jpg">Next</span>
                                        </button>
                                        <button type="button" className="btn-jpg btn-blue tooltip-jpg" onClick={event => resetImage(event)}><i className="bi bi-arrow-clockwise"></i>
                                            <span className="tooltiptext-jpg">Reset</span>
                                        </button>
                                        <button type="button" className="btn-jpg btn-blue tooltip-jpg" onClick={event => openImage(event)}><i className="bi bi-box-arrow-up-right"></i>
                                            <span className="tooltiptext-jpg">Open Image in Window</span>
                                        </button>
                                        <button className="btn-jpg btn-blue tooltip-jpg" onClick={event => showReportArea(event)}><i className="bi bi-clipboard2-data-fill"></i>
                                            <span className="tooltiptext-jpg">Show/hide Report</span>
                                        </button>

                                        <button className="btn-jpg btn-blue tooltip-jpg" onClick={event => showImageArea(event)}><i className="bi bi-card-image"></i>
                                          <span className="tooltiptext-jpg">Show/hide Image</span>
                                        </button>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>

                      <div style={{display:"none"}} className="icol-7 col-s-12 reportarea" >
                          <div className="p-2 border-rounded-crimson image-container mt-1">
                              {/* Embedded Report Viewer 
                              <object data="resources/report.pdf" type="application/pdf" width="100%" height="100%">
                                  <p>Alternative text - include a link <a href="resources/report.pdf">to the PDF!</a></p>
                              </object>
                              */}

                              
                          </div>
                      </div>

                      <div className="icol-7 col-s-12 reportarea row justify-content-center pb-3" id="reportarea">
                        <div style={{paddingLeft:"0.9rem"}}  className="container wrapper">
                            <div className="page-wrapper">
                                <div className="row">
                                  <div className="col-12 col-lg-9 col-md-9">
                                    <ul className="nav nav-tabs" id="myReportTab" role="tablist">
                                      <li className="nav-item" role="presentation">
                                        <button className="nav-link active" id="report1-tab" data-bs-toggle="tab" data-bs-target="#report1-tab-pane" type="button" role="tab" aria-controls="report1-tab-pane" aria-selected="true" onClick={event => tabReportClick(event, 1) }><small><b>Report1 </b></small></button>
                                      </li>
                                      <li className="nav-item" role="presentation">
                                        <button className="nav-link" id="report2-tab" data-bs-toggle="tab" data-bs-target="#report2-tab-pane" type="button" role="tab" aria-controls="report2-tab-pane" aria-selected="false" onClick={event => tabReportClick(event, 2) }><small><b>Report2 </b></small></button>
                                      </li>
                                      <li className="nav-item" role="presentation">
                                      <button className="nav-link" id="report3-tab" data-bs-toggle="tab" data-bs-target="#report3-tab-pane" type="button" role="tab" aria-controls="report3-tab-pane" aria-selected="false" onClick={event => tabReportClick(event, 3) }><small><b>Report3 </b></small></button>
                                      </li>
                                      <li className="nav-item" role="presentation">
                                      <button className="nav-link" id="report4-tab" data-bs-toggle="tab" data-bs-target="#report4-tab-pane" type="button" role="tab" aria-controls="report4-tab-pane" aria-selected="false" onClick={event => tabReportClick(event, 4) }><small><b>Report4 </b></small></button>
                                      </li>
                                    </ul>
                                  </div>
                                  <div className="col-12 col-lg-3 col-md-3 mt-2">

                                    <button className="btn-jpg btn-blue tooltip-jpg" onClick={event => showImageArea(event)}><i className="bi bi-card-image"></i>
                                      <span className="tooltiptext-jpg">Show/hide Image</span>
                                    </button>

                                    <button type="button" className="btn btn-secondary btn-sm bi bi-plus-square-fill float-right m-1" id="btnreportadd" onClick={event => tabAddClick() }> ADD</button>
                                    <button type="button" className="btn btn-secondary btn-sm bi bi-x-square-fill float-right m-1" id="btnreportremove" onClick={event => tabRemoveClick() }> REMOVE(LAST)</button>

                                    <select className="form-select form-select-sm float-right m-1" style={{ width: "160px"}} id="ddlLineHeight" name="ddlLineHeight" onChange={event => lineHeightChange()}>
                                      <option value="">Line Height - Default</option>
                                      <option value="1">Line Height - 1</option>
                                      <option value="1.3">Line Height - 1.3</option>
                                      <option value="1.5">Line Height - 1.5</option>
                                      <option value="1.8">Line Height - 1.8</option>
                                      <option value="2">Line Height - 2</option>
                                      <option value="2.3">Line Height - 2.3</option>
                                      <option value="2.5">Line Height - 2.5</option>
                                      <option value="2.8">Line Height - 2.8</option>
                                    </select>
                                  </div>
                                </div>
                                
                            </div>
                        </div>
                        <div className="col-lg-12 col-12">
                            <div className="form-group" style={{ lineHeight: reportLineHeight}} > 
                                {/*<label for="" className="font-size14">Report Content:</label>*/}
                                <Editor
                                  editorState={editorState}
                                  onEditorStateChange={setEditorState}
                                  wrapperClassName="wrapper-class"
                                  editorClassName="editor-class"
                                  toolbarClassName="toolbar-class"
                                  handlePastedText={() => false}
                                  spellCheck={true}
                                />
                            </div>
                        </div>
                      </div>
                      
                  </div>  
                    
                </div>
                

                <div className="modal-footer pt-2">
                  <div className="row justify-content-center">
                        <div id="divPrintReport" className="col-lg-3 col-3"><button type="button"
                                className="btn btn-secondary btn-sm btn-block bi bi-send-fill" id="btnPrintReport" onClick={event => openSubmitReport(event, 'PRINT', null, '')}> PRINT </button></div>
                        <div id="divSubmitReport" className="col-lg-3 col-3"><button type="button"
                                className="btn btn-secondary btn-sm btn-block bi bi-send-fill" id="btnSubmitReport" onClick={event => openSubmitReport(event, 'SAVE', null, '')}> SAVE </button></div>
                        <div id="divSubmitReportSignedOff" className="col-lg-3 col-6"><button type="button"
                                className="btn btn-secondary btn-sm btn-block bi bi-check-square-fill" id="btnSubmitReportSignedOff" onClick={event => openSubmitReport(event, 'SAVE_SIGNOFF', null, '')}> SAVE & SIGN OFF</button></div>
                        <div className="col-lg-3 col-3"><button type="button"
                                className="btn btn-secondary btn-sm btn-block bi bi-x-square" id="btnSubmitReportClose" onClick={event => openSubmitReport(event, 'CLOSE', null, '')}> CLOSE </button></div>
                    </div>
                </div>
            </div>
        </div>
        
        <div id="openSubmitReportPreview" className="modal closed">

            {/*<!--Modal content -->*/}
            <div className="report-modal-content-preview">
                <div className="modal-header pt-2">
                    <span className="close" onClick={event => openSubmitReportPreview(event, 'CLOSE', null)}>&times;</span>
                    <h6 className="mb-0"><i className="bi bi-clipboard-check-fill"></i> Submit Report Preview: <span id="spnsubmit_patient_preview"></span>
                    <input type="hidden" id="hidc_key_submit_preview" />
                    <input type="hidden" id="hidp_key_submit_preview" />
                    <input type="hidden" id="hidreport_count" />
                    <input type="hidden" id="hidreport1-tab" />
                    <input type="hidden" id="hidreport2-tab" />
                    <input type="hidden" id="hidreport3-tab" />
                    <input type="hidden" id="hidreport4-tab" />
                    </h6>
                </div>
                <div className="modal-body">
                  <div className="row justify-content-center">
                    <div className="PreviewContent" id="divPreviewContent">
                    </div>
                  </div>
              
                  <div className="row justify-content-center">
                        <button type="button"
                                className="btn btn-secondary btn-sm btn-block bi bi-check-square-fill" id="btnSubmitReportSignedOffPreview" onClick={event => openSubmitReportPreview(event, 'SAVE_SIGNOFF_SUBMIT', null)}> SUBMIT(SIGN OFF)</button>
                  </div>
                </div>
            </div>
        </div>

        {/*<!--Custom Modal Open Notes -->*/}
        <div id="attachNotes" className="modal closed">

            {/*<!--Modal content -->*/}
            <div className="notes-modal-content">
                <div className="modal-header pt-2">
                    <span className="close" onClick={event => openNotes(event, 'CLOSE')}>&times;</span>
                    <h6 className="mb-0"><i className="bi bi-clipboard-check-fill"></i> Notes: <span id="spnnotes_patient"></span></h6>
                </div>
                <div className="modal-body" style={{ paddingBottom: "0px"}}>
                    <div className="row justify-content-center pb-3">
                        <div className="col-lg-12 col-12 ps-1 pe-1">
                            <div className="form-group">
                                <div className="overflow-y-scroll">
                                  <label for="divp_comments" className="font-size14">History Notes:</label>
                                  <div className="note_comments" id="divp_comments" style={{ fontSize: "12px"}}>
                                    &nbsp;
                                  </div>
                                </div>

                                <label for="txtp_notes" className="font-size14">Add Note:</label>
                                <textarea className="form-control font-size14" rows="2" id="txtp_notes"></textarea>
                                <input type="hidden" id="hidc_key_notes" />
                                <input type="hidden" id="hidp_key_notes" />
                            </div>
                        </div>
                    </div>
                    
                </div>
                <div className="modal-footer pt-2">
                  <div className="row justify-content-end"> 
                      <div className="col-lg-6 col-4">
                        <input id="notesFiles" title="Select multiple files to upload" className="form-control-sm"
                            type="file" multiple="multiple" onChange={handleChangeNotesFile} />
                      </div>
                      <div className="col-lg-3 col-4"><button type="button"
                              className="btn btn-secondary btn-sm btn-block bi bi-send-fill" id="btnNotesSave" onClick={event => openNotes(event, 'SAVE')}> SAVE </button>
                      </div>
                      <div className="col-lg-3 col-4"><button type="button"
                              className="btn btn-secondary btn-sm btn-block bi bi-x-square" id="btnNotesClose" onClick={event => openNotes(event, 'CLOSE', null, null)}> CLOSE </button>
                      </div>
                  </div>
                </div>
            </div>
        </div>

        {/*<!--Custom Modal Open Notes -->*/}
        <div id="activityLog" className="modal closed">
          {/*<!--Modal content -->*/}
          <div className="activitylog-modal-content">
              <div className="modal-header pt-2">
                  <span className="close" onClick={event => openActivityLog(event, 'CLOSE', null, null)}>&times;</span>
                  <h6 className="mb-0"><i className="bi bi-clipboard-check-fill"></i> Activity Log: <span id="spnlog_patient"></span></h6>
              </div>
              
              <div className="modal-body" style={{overflow:"auto"}}>
                <div className="card-body tele-table-padding">
                  {/* tele-table-rowbg1 */}
                        
                  {Object.keys(activitylogData).map((data, i) => (
                    <div key={i} className="">
                      <div className="item">
                          <div className="image">
                            <div>
                              <div className="img-div">
                                {(activitylogData[i].activity_action === 'Uploaded Patient' ?  
                                    <img alt="" src="img/upload.png" />    
                                    : 
                                      activitylogData[i].activity_action === 'Printed Report' ?  
                                      <img alt="" src="img/print.png" />    
                                      : 
                                        activitylogData[i].activity_action === 'SignedOff Report' ?  
                                        <img alt="" src="img/report.png" />    
                                        : 
                                          activitylogData[i].activity_action === 'Locked Patient' || activitylogData[i].activity_action === 'Locked Study' ?  
                                          <img alt="" src="img/lock.png" />    
                                          : 
                                            activitylogData[i].activity_action === 'Removed Lock Patient' || activitylogData[i].activity_action === 'Unlocked Study' ?  
                                            <img alt="" src="img/unlocked.png" />    
                                            : 
                                            <img alt="" src="img/message.png" />        
                                )}
                                
                              </div>
                              <span>
                                {activitylogData[i].activity_time} 
                              </span>
                            </div>
                          </div>
                          <div className="details">
                            <div>
                              <h1>
                                {activitylogData[i].activity_action}:&nbsp;

                                {(authUser?.user_type === 'U' ?  
                                  (activitylogData[i].user_type === 'D' ?  
                                      <span>Doctor</span>
                                      : <span>{activitylogData[i].user_name}</span>
                                  )
                                  : 
                                  (authUser?.user_type === 'D' || authUser?.user_type === 'R' ?  
                                      (activitylogData[i].user_type === 'U' ?  
                                          <span>Center User</span>
                                          : <span>{activitylogData[i].user_name}</span>
                                      )
                                      : 
                                      (activitylogData[i].user_type === 'D' ?  
                                          <span>{activitylogData[i].user_title} {activitylogData[i].user_name} ({activitylogData[i].user_id})</span>
                                          : <span>{activitylogData[i].user_name}</span>
                                      )
                                  )
                              )}
                              </h1>
                              
                              <p>{activitylogData[i].activity_remarks}</p>
                              
                            </div>
                          </div>
                        </div>
                        
                    </div>
                          
                  ))}
                        
                  </div>
              </div>

              <div className="modal-footer pt-2">
                <div className="row justify-content-center">
                    <div className="col-lg-6 col-6"><button type="button"
                            className="btn btn-secondary btn-sm btn-block bi bi-x-square" id="btnActityLogClose" onClick={event => openActivityLog(event, 'CLOSE', null, null)}> CLOSE </button></div>
                </div>
              </div>

          </div>
        </div>

        <div id="modal2" className="modal closed">

            {/*<!--Modal content -->*/}
            <div className="modal-content">
                <div className="modal-header pt-2">
                    <span className="close" id="close-button2" onClick={event => openModal2(event, 'CLOSE')}>&times;</span>
                    <h6 className="mb-0"><i className="bi bi-clipboard-check-fill"></i> Notes</h6>
                </div>
                <div className="modal-body">
                    <div className="row justify-content-center pb-3">
                        <div className="col-lg-12 col-12 ps-1 pe-1">
                            <div className="form-group mt-2">
                                <label for="" className="font-size14">Add Note:</label>
                                <textarea className="form-control font-size14" rows="2"  name="history"></textarea>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-lg-4 col-12"><button type="button"
                                className="btn btn-secondary btn-sm btn-block bi bi-send-fill"> SAVE DETAILS</button></div>
                    </div>
                </div>
            </div>
        </div>
        {/*<!--End of Custom Modal Type 2 -->*/}

        {/*<!--Custom Modal Type 3 -->*/}
        <div id="modal3" className="modal closed">

            {/*<!-- Modalcontent -->*/}
            <div className="modal-content">
                <div className="modal-header pt-2">
                    <span className="close" id="close-button3" onClick={event => openContactInfo(event, 'CLOSE')}>&times;</span>
                    <h6 className="mb-0"><i className="bi bi-person-lines-fill"></i> Contact Info</h6>
                </div>
                <div className="modal-body">
                    <div className="row justify-content-center pb-3">
                        <div className="col-lg-6 col-12 ps-1 pe-1">
                            <div className="form-group mt-2">
                                <label for="" className="font-size14">Email:</label>
                                <input type="text" placeholder="Email" required="required" className="form-control" id="Email" name="Email" />
                            </div>
                        </div>
                        <div className="col-lg-6 col-12 ps-1 pe-1">
                            <div className="form-group mt-2">
                                <label for="" className="font-size14">Contact Number:</label>
                                <input type="text" placeholder="Contact Number" required="required" className="form-control" id="Contact" name="Contact" />
                            </div>
                        </div>
                        <div className="col-lg-12 col-12 ps-1 pe-1">
                            <div className="form-group mt-2">
                                <label for="" className="font-size14">Address:</label>
                                <textarea className="form-control font-size14" rows="2" id="address" name="address"></textarea>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-lg-4 col-12"><button type="button"
                                className="btn btn-secondary btn-sm btn-block bi bi-send-fill"> SAVE DETAILS</button></div>
                    </div>
                </div>
                <div className="modal-footer pt-2"><p className="mb-0 text-center font-size12">Please add this information as this will show in the invoice</p></div>
            </div>
        </div>
        {/*<!--End of Custom Modal Type 3 -->*/}

        {/*<!--Custom Modal for Alert -->*/}
        <div id="modal_alert">
          {/*<ToastContainer limit={3}></ToastContainer>*/}
          <ToastContainer limit={1} stacked role="alert" autoClose={autoCloseTime} />
        </div>
        {/*<!--End of Custom Modal for Alert -->*/}

        {/*<!--Custom Modal for Success -->*/}
        <div id="modal_success" className="modal modal-confirm closed">

            {/*<!--Modal content -->*/}
            <div className="success-modal-content">
                <div className="modal-header-success">
                    <div className="icon-box"><i className="fa fa-check" aria-hidden="true"></i></div>
                    <h4 className="modal-title mb-0 text-center">Success</h4>
                </div>
                <div className="modal-body">
                    <div className="row justify-content-center pb-3">
                        <div className="col-lg-12 col-12 ps-1 pe-1 text-center">
                            <p>Form has been created successfully.</p>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-lg-12 col-12"><button type="button"
                                className="btn btn-success btn-sm btn-block" id="close-button-success" onClick={event => openModalSuccess(event, 'CLOSE')}> OK</button></div>
                    </div>
                </div>
            </div>
        </div>
        {/*<!--End of Custom Modal for Success -->*/}

        {/*<!--Custom Modal for Error -->*/}
        <div id="modal_error" className="modal modal-error closed">

            {/*<!-- Modal content -->*/}
            <div className="success-modal-content">
                <div className="modal-header-error">
                    <div className="icon-box"><i className="fa fa-times" aria-hidden="true"></i></div>
                    <h4 className="modal-title mb-0 text-center">Error!</h4>
                </div>
                <div className="modal-body">
                    <div className="row justify-content-center">
                        <div className="col-lg-12 col-12 ps-1 pe-1 text-center">
                            <p>An unexpected error has been occured.</p>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-lg-12 col-12"><button type="button"
                                className="btn btn-danger btn-sm btn-block" id="close-button-error" onClick={event => openModalError(event, 'CLOSE')}> OK</button></div>
                    </div>
                </div>
            </div>
        </div>
        {/*<!-- End of Custom Modal for Error -->*/}
        
        </div>
    );
}

